/**
 * @voltxampere/web — Turkish bundle (Sprint 11).
 *
 * Sprint 11 covers ~40 keys for the shell. Sprint 18 expands
 * to the full ~200-key surface (canvas / inspector / waveform).
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

export const tr = {
  // App
  "app.title": "Volt × Ampere",
  "app.tagline": "Elektrik-elektronik stüdyosu",

  // Topbar
  "topbar.untitled": "Adsız Devre",
  "topbar.user.menu": "Hesap",
  "topbar.locale.toggle": "EN",

  // Sprint 18 Paket B — nav-tabs
  "nav.tab.landing": "Açılış",
  "nav.tab.simulator": "Simülatör",
  "nav.tab.presets": "Devreler",
  "nav.tab.inspector": "Inspector",
  "nav.tab.settings": "Ayarlar",
  "shortcut.pane.landing": "Açılış sayfasına geç",
  "shortcut.pane.simulator": "Simülatöre geç",
  "shortcut.pane.presets": "Hazır devrelere geç",
  "shortcut.pane.inspector": "Inspector sayfasına geç",
  "shortcut.pane.settings": "Ayarlara geç",

  // Sprint 18 Paket B B7 — Settings page (Ayarlar)
  "settings.nav.label": "Ayarlar",
  "settings.tab.appearance": "Görünüm",
  "settings.tab.language": "Dil & Bölge",
  "settings.tab.simulation": "Simülasyon",
  "settings.tab.shortcuts": "Klavye Kısayolları",
  "settings.tab.a11y": "Erişilebilirlik",
  "settings.tab.about": "Hakkında",
  "settings.appearance.title": "Görünüm",
  "settings.appearance.sub": "Temanın karakteri, canvas arkaplanı, sembol standardı, kablo eğrisi.",
  "settings.appearance.theme.label": "Tema",
  "settings.appearance.theme.row.title": "Ana renk dili",
  "settings.appearance.theme.row.desc": "Zenit varsayılan · gece gözleme + bakır aksan",
  "settings.appearance.brightness.row.title": "Parlaklık",
  "settings.appearance.brightness.row.desc": "OLED ekranlarda koyuya çek, retina ekranlarda aç",
  "settings.appearance.canvas.label": "Canvas",
  "settings.appearance.canvas.background.title": "Arkaplan stili",
  "settings.appearance.canvas.background.desc": "Grid stilinin karakteri",
  "settings.appearance.canvas.wire.title": "Kablo eğrisi",
  "settings.appearance.canvas.wire.desc": "Kablonun yol alma şekli",
  "settings.appearance.canvas.symbol.title": "Sembol standardı",
  "settings.appearance.canvas.symbol.desc": "IEC avrupa zigzag · ANSI amerika dikdörtgen",
  "settings.appearance.canvas.fx.title": "Akım akışı animasyonu",
  "settings.appearance.canvas.fx.desc":
    "Transient simülasyon sırasında kabloda akım akışını brass-hot partiküllerle gösterir. Sistem 'reduced-motion' tercihi açıksa otomatik kapanır.",
  "settings.appearance.canvas.fx.option.on": "Açık",
  "settings.appearance.canvas.fx.option.off": "Kapalı",
  "settings.appearance.canvas.heatmap.title": "Voltaj haritası",
  "settings.appearance.canvas.heatmap.desc":
    "Node potansiyellerini renkli halo halkalarıyla gösterir. Yüksek brass-hot, orta slate-blue, düşük deep-blue. Statik görsel — reduced-motion etkilemez.",
  "settings.appearance.canvas.heatmap.option.on": "Açık",
  "settings.appearance.canvas.heatmap.option.off": "Kapalı",
  "settings.appearance.canvas.gradient.title": "Voltaj gradyanı",
  "settings.appearance.canvas.gradient.desc":
    "Kabloları net voltajına göre renklendirir (HSL space lerp). Heatmap'ten bağımsız toggle, statik görsel.",
  "settings.appearance.canvas.gradient.option.on": "Açık",
  "settings.appearance.canvas.gradient.option.off": "Kapalı",
  // Sprint 31 — ses ayarları (Hoparlör + Buzzer master kontrolleri).
  "settings.audio.title": "Ses",
  "settings.audio.masterVolume": "Ses seviyesi",
  "settings.audio.masterVolume.desc":
    "Hoparlör ve buzzer çıktısının ana ses seviyesi (0..100). Sıfır = sessiz, kullanıcı 'Sessiz' toggle'ı ile aynı etki.",
  "settings.audio.muted": "Sessiz",
  "settings.audio.muted.desc":
    "Tüm ses çıktısını kapatır. Master ses seviyesi 0 olarak set etmekle aynı; AYARLAR kalıcı kayıt için bu daha uygun.",
  "settings.audio.muted.option.on": "Sessiz",
  "settings.audio.muted.option.off": "Açık",
  "settings.audio.autoplay.hint":
    "Tarayıcı politikaları nedeniyle ilk ses oynatımı için bir tıklama gerekir. Run / F5 / ses kaydırıcısına bastığınızda ses başlar. Sistem 'reduce-motion' tercihi açıksa ses otomatik kapanır.",
  "settings.audio.autoplay.dismiss": "Tamam, anladım",
  // Sprint 37-4 — Hasar Sesleri (8 damage sound effects toggle).
  "settings.damageAudio.title": "Hasar Sesleri",
  "settings.damageAudio.sub":
    "Bileşen patladığında / kondansatör şiştiğinde / direnç yandığında 8 ses efekti çalar (LED pop, kapasitör bang, sizzle, crackle, hiss, zap, creak, cooldown).",
  "settings.damageAudio.enabled": "Hasar ses efektleri",
  "settings.damageAudio.enabled.desc":
    "Patlama animasyonlarına eşlik eden 8 Tone.js ses efekti. Master ses ayarları + sistem reduce-motion tercihi ayrıca uygulanır (6-katman audio guard).",
  "settings.damageAudio.enabled.option.on": "Açık",
  "settings.damageAudio.enabled.option.off": "Kapalı",
  // Sprint 32 — zaman scrubber + bookmark UI.
  "scrubber.label": "Zaman çizelgesi",
  "scrubber.live": "Canlı",
  "bookmark.add": "Pin ekle",
  "bookmark.placeholder": "Bu anda ne oldu?",
  "bookmark.delete": "Sil",
  "bookmark.close": "Kapat",
  "bookmark.maxLength": "{count}/280 karakter",
  // Sprint 33-4 — Sürekli Akış (always-live + idle detection) toggles.
  "settings.liveMode.title": "Sürekli Akış",
  "settings.liveMode.sub":
    "Devre değiştiğinde otomatik canlı simülasyon ve hareketsizlikte güç tasarrufu.",
  "settings.liveMode.alwaysLive": "Her zaman canlı",
  "settings.liveMode.alwaysLive.desc":
    "Devre değiştiğinde otomatik olarak yeniden simüle eder. Run butonuna basma ihtiyacı kalkar.",
  "settings.liveMode.alwaysLive.option.on": "Açık",
  "settings.liveMode.alwaysLive.option.off": "Kapalı",
  "settings.liveMode.idleDetection": "Güç tasarrufu",
  "settings.liveMode.idleDetection.desc":
    "3 dakika hareketsizlikten sonra çerçeve hızını düşürür (60fps → 10fps). CPU ve batarya tasarrufu.",
  "settings.liveMode.idleDetection.option.on": "Açık",
  "settings.liveMode.idleDetection.option.off": "Kapalı",
  // Sprint 34-5 — Termal görüntüleme toggle.
  "settings.thermal.title": "Termal",
  "settings.thermal.sub":
    "Bileşen sıcaklığını canvas'ta hot-spot halo'larla gösterir. Yüksek güç dissipation kırmızı, düşük orange.",
  "settings.thermal.visualization": "Termal görüntüleme",
  "settings.thermal.visualization.desc":
    "Canvas'ta seçili olmayan tüm bileşenlerin sıcaklığını canlı renk halo olarak çizer. Inspector'daki Sıcaklık satırı her zaman görünür.",
  "settings.thermal.visualization.option.on": "Açık",
  "settings.thermal.visualization.option.off": "Kapalı",
  // Sprint 35-5 — Patlama Efektleri toggles (master + smoke separate).
  "settings.explosion.title": "Patlama Efektleri",
  "settings.explosion.sub":
    "Bileşen aşırı ısındığında LED patlaması, kondansatör şişmesi, direnç yanması gibi görsel efektler. Sistem 'reduce-motion' tercihi açıksa otomatik kapanır.",
  "settings.explosion.enabled": "Patlama animasyonları",
  "settings.explosion.enabled.desc":
    "LED 5-aşamalı patlama, kondansatör şişme, direnç yanması animasyonlarını gösterir. Severity ≥ 1.2'de tetiklenir.",
  "settings.explosion.enabled.option.on": "Açık",
  "settings.explosion.enabled.option.off": "Kapalı",
  "settings.explosion.smokeEnabled": "Duman partikülleri",
  "settings.explosion.smokeEnabled.desc":
    "Direnç yanması ve kondansatör patlamasında duman partikülleri yükselir. Performans için ayrı kapatılabilir (200 partikül cap).",
  "settings.explosion.smokeEnabled.option.on": "Açık",
  "settings.explosion.smokeEnabled.option.off": "Kapalı",
  // Sprint 36-5 — Hasar (kalıcı hasar + kablo aşırı yük) toggles.
  "settings.damage.title": "Hasar",
  "settings.damage.sub":
    "Patlayan bileşenler kalıcı hasarlı kalır ve devreden çıkar. Kablodan akım sınırı aşarsa kablo erir ve kopar. 'Devreyi Sıfırla' ile geri getirilir.",
  "settings.damage.persistAcrossReload": "Hasar kalıcı (sayfa yenilenince korunur)",
  "settings.damage.persistAcrossReload.desc":
    "Hasarlı bileşenlerin durumu IDB'de saklanır. Kapatırsanız her sayfa yenilenmesinde devre sağlıklı başlar.",
  "settings.damage.persistAcrossReload.option.on": "Açık",
  "settings.damage.persistAcrossReload.option.off": "Kapalı",
  "settings.damage.wireOverloadEnabled": "Kablo aşırı yük tespiti",
  "settings.damage.wireOverloadEnabled.desc":
    "Kablodan geçen akım sınırı aşarsa kablo gradient sarı→kırmızı→siyah ile erir ve kopar (default 5A insulation, 10A bakır). Kapatırsanız kablolar her zaman sağlam kalır.",
  "settings.damage.wireOverloadEnabled.option.on": "Açık",
  "settings.damage.wireOverloadEnabled.option.off": "Kapalı",
  "canvas.restart.label": "Devreyi Sıfırla",
  "canvas.restart.aria": "Hasarlı bileşenleri sıfırla ve devreyi yeniden çalıştır",
  "inspector.damaged": "HASARLI",
  "settings.appearance.deferred":
    "Bu ayarların canvas backend'i Sprint 19'da bağlanır; B7'de görsel ön gösterim.",
  "settings.language.title": "Dil & Bölge",
  "settings.language.sub": "Kullanıcı arayüzü dili. Bilim terimleri orijinal kalır.",
  "settings.language.locale.label": "Dil",
  "settings.language.locale.row.title": "Arayüz dili",
  "settings.language.locale.row.desc": "TR (varsayılan) · EN ikinci dil",
  "settings.simulation.title": "Simülasyon",
  "settings.simulation.sub":
    "AC süpürme, transient analiz ve sıcaklık varsayılanları — yeni devre açılışı için.",
  "settings.simulation.tolerances.label": "Toleranslar",
  "settings.simulation.reltol.title": "Relatif tolerans",
  "settings.simulation.reltol.desc": "DC çözümünde reltol (sabit, ngspice varsayılanı)",
  "settings.simulation.abstol.title": "Mutlak tolerans",
  "settings.simulation.abstol.desc": "Voltaj eşiği için abstol (sabit, ngspice varsayılanı)",
  "settings.simulation.maxIter.title": "Maks. iterasyon",
  "settings.simulation.maxIter.desc": "Newton döngüsü güvenlik tavanı (sabit)",
  // Sprint 24 A3 — AC defaults form
  "settings.simulation.ac.label": "AC süpürme varsayılanları",
  "settings.simulation.ac.fStart.title": "Başlangıç frekansı",
  "settings.simulation.ac.fStart.desc": "Hertz cinsinden — minimum 1 mHz",
  "settings.simulation.ac.fStop.title": "Bitiş frekansı",
  "settings.simulation.ac.fStop.desc": "Hertz cinsinden — maksimum 1 GHz",
  "settings.simulation.ac.points.title": "Nokta sayısı",
  "settings.simulation.ac.points.desc": "Linear için toplam, dec/oct için decade/oktav başına",
  "settings.simulation.ac.sweep.title": "Süpürme tipi",
  "settings.simulation.ac.sweep.desc": "Doğrusal · oktav · dekat · log-doğrusal",
  "settings.simulation.ac.sweep.lin": "Doğrusal",
  "settings.simulation.ac.sweep.oct": "Oktav",
  "settings.simulation.ac.sweep.dec": "Dekat",
  "settings.simulation.ac.sweep.log": "Logaritmik",
  // Sprint 24 A3 — Transient defaults form
  "settings.simulation.tran.label": "Transient varsayılanları",
  "settings.simulation.tran.tStop.title": "Bitiş zamanı",
  "settings.simulation.tran.tStop.desc": "Saniye cinsinden — analizin durma anı",
  "settings.simulation.tran.maxStep.title": "Maks. adım boyutu",
  "settings.simulation.tran.maxStep.desc": "Saniye — adaptif kontrolcünün üst sınırı",
  // Sprint 24 A3 — Temperature
  "settings.simulation.temp.label": "Sıcaklık",
  "settings.simulation.temp.row.title": "Çevre sıcaklığı",
  "settings.simulation.temp.row.desc": "°C cinsinden — yarıiletken modeller bu değeri kullanır",
  // Sprint 24 A3 — Reset
  "settings.simulation.reset.title": "Varsayılana sıfırla",
  "settings.simulation.reset.desc": "AC, transient ve sıcaklık alanlarını fabrika ayarlarına sar.",
  "settings.simulation.reset.button": "Sıfırla",
  // Sprint 24 A4 — appearance toggle option labels (Görünüm sub-tab,
  // canvas-style + wire-curve + symbol-standard groups). Sprint 24
  // A3'te hardcoded TR olarak shipped, A4 i18n closure'da bundle'a
  // taşındı.
  "settings.appearance.canvas.background.option.night": "Gece",
  "settings.appearance.canvas.background.option.technical": "Teknik",
  "settings.appearance.canvas.background.option.paper": "Kağıt",
  "settings.appearance.canvas.background.option.blank": "Boş",
  "settings.appearance.canvas.wire.option.catenary": "Catenary",
  "settings.appearance.canvas.wire.option.manhattan": "Manhattan",
  "settings.appearance.canvas.wire.option.linear": "Düz",
  "settings.appearance.canvas.symbol.option.iec": "IEC",
  "settings.appearance.canvas.symbol.option.ansi": "ANSI",
  "settings.shortcuts.title": "Klavye Kısayolları",
  "settings.shortcuts.sub": "Cmd/Ctrl ⌘ — Mac veya PC için aynı kısayollar.",
  "settings.shortcuts.list.label": "Kısayollar",
  "settings.shortcuts.row.palette": "Komut paleti aç/kapa",
  "settings.shortcuts.row.help": "Kısayol listesi",
  "settings.shortcuts.row.runDc": "DC çalıştır",
  "settings.shortcuts.row.runTr": "Transient çalıştır (run-once)",
  "settings.shortcuts.row.toggleLive": "Transient live mode (toggle)",
  "settings.shortcuts.row.waveform": "Waveform paneli (toggle)",
  "settings.shortcuts.row.import": "İçe aktar dialog'u",
  "settings.shortcuts.row.export": "Dışa aktar dialog'u",
  "settings.shortcuts.row.preset": "Hazır devreleri aç",
  "settings.shortcuts.row.pane": "Sayfalar arası geçiş",
  "settings.a11y.title": "Erişilebilirlik",
  "settings.a11y.sub": "WCAG AA uyumlu, hareket azaltma, kontrast modları.",
  "settings.a11y.system.label": "Sistem ayarları",
  "settings.a11y.reduceMotion.title": "Hareket azaltma",
  "settings.a11y.reduceMotion.desc":
    "prefers-reduced-motion uyumlu — animasyonları kısıtla (ilk açılış sistem tercihini takip eder)",
  // Sprint 80.Z L-AYARLAR-2 — Hareket azaltma toggle option labels.
  "settings.a11y.reduceMotion.option.off": "Kapalı",
  "settings.a11y.reduceMotion.option.on": "Açık",
  "settings.a11y.contrast.title": "Kontrast modu",
  "settings.a11y.contrast.desc": "Yüksek kontrast — düşük görmeli kullanıcılar için",
  // Sprint 80.Z B1 — Erişilebilirlik kontrast toggle option labels.
  "settings.a11y.contrast.option.normal": "Normal",
  "settings.a11y.contrast.option.high": "Yüksek",
  "settings.a11y.fontSize.title": "Yazı tipi boyutu",
  "settings.a11y.fontSize.desc": "Küçük → Büyük (S/M/L/XL)",
  "settings.about.title": "Hakkında",
  "settings.about.sub": "Sürüm bilgisi, lisans, stüdyo hakkında.",
  "settings.about.version.label": "Sürüm",
  "settings.about.codename": "Reference Parity",
  "settings.about.version.body":
    "Volt × Ampere v3 — TypeScript monorepo, Lit web component, ngspice parity engine. Tarayıcıda açılır, kayıt istemez.",
  "settings.about.license.label": "Lisans",
  "settings.about.license.body":
    "MIT — açık kaynak, ticari kullanıma açık. Engine + UI paketleri MIT, app shell proprietary.",
  "settings.about.studio.label": "Stüdyo",
  "settings.about.studio.body":
    "360 Studio · Göksen Olgun · MMXXVI. Bir gözlem aleti — sadece devre, sadece ölçü.",
  "settings.about.cta.title": "Simülatöre dön",
  "settings.about.cta.desc": "Hakkında okuma bitti — devreye dönelim.",
  "settings.about.cta.action": "Aç →",

  // Sprint 18 Paket B B6 — INSPECTOR detail page
  "inspector.page.caption": "Seçili Bileşen · Detay Görünümü",
  "inspector.page.empty.title": "Hiçbir bileşen seçili değil",
  "inspector.page.empty.hint":
    "Simülatöre dönüp bir bileşene tıkla. Buradaki detay görünümü o bileşeni büyüteç altında gösterir.",
  "inspector.page.empty.cta": "Simülatöre dön →",
  "inspector.page.section.value": "Değer",
  "inspector.page.section.params": "Parametreler",
  "inspector.page.section.actions": "Eylem",
  "inspector.page.action.editInSim": "Simülatörde düzenle →",
  "inspector.page.params.empty": "Sayısal parametre yok.",
  "inspector.page.live.bindHint": "Bir kanala probe bağlayın — değerler buraya akar.",
  "inspector.page.live.voltage": "Gerilim (RMS)",
  "inspector.page.live.voltage.caption": "Etkin değer — kalıcı ısı eşdeğeri",
  "inspector.page.live.peak": "Tepe Gerilim",
  "inspector.page.live.peak.caption": "Mutlak değerce en büyük örnek",
  "inspector.page.live.peakToPeak": "Tepe-Tepe",
  "inspector.page.live.peakToPeak.caption": "Maksimum dalgalanma genliği",
  "inspector.page.live.average": "Ortalama Gerilim",
  "inspector.page.live.average.caption": "DC bileşeni — periyot ortalaması",
  "inspector.page.subline.generic": "Devrenin tek bir hattı; akımın izi burada okunur.",

  // Sprint 18 Paket B B3 — Landing page (Açılış)
  "landing.caption.observatorium": "Observatorium Electricum",
  "landing.hero.subtitle": "bir gözlem aleti.",
  "landing.hero.lede":
    "Tarayıcında açılan, <em>LTspice</em> doğruluğunda, <em>Falstad</em> akıcılığında. Kayıt yok, ücret yok. Sadece devre, sadece ölçü, sadece <em>akımın izi</em>.",
  // Sprint 23 E1 — D-23-1 hibrit closure: CTA copy "Simülatörü aç" →
  // "Simülatöre git". 4. feature kartı (Roman IV) — Açık kaynak.
  "landing.cta.openSimulator": "Simülatöre git →",
  "landing.cta.presets": "Hazır devreler",
  "landing.feature.openSource.title": "Açık kaynak",
  "landing.feature.openSource.desc":
    "Engine MIT lisansla açık. Her sentinel testten geçen formül kamuya ait — kullan, çatalla, geliştir.",
  "landing.sep.what": "Ne Yapar",
  "landing.feature.accuracy.title": "Hata yapmaz.",
  "landing.feature.accuracy.desc":
    "Modified Nodal Analysis, Newton-Raphson convergence, Cuthill-McKee reorder. <em>ngspice</em> sonuçlarıyla ±0.15V paritede.",
  "landing.feature.live.title": "Canlı hisseder.",
  "landing.feature.live.desc":
    "Akım akışı meteor gibi kabloda akar. Gerilim renk olarak okunur. Her ölçüm — <em>fısıltıdan önce</em>.",
  "landing.feature.localized.title": "Türkçe önce.",
  "landing.feature.localized.desc":
    "Direnç, kapasitör, diyot. Bilim dilinde değil, <em>kendi dilinde</em>. Terimlerin arkasında İngilizcesi duruyor.",
  "landing.stat.components": "bileşen",
  "landing.stat.tests": "birim test",
  "landing.stat.dependencies": "bağımlılık",
  "landing.stat.parity": "ngspice parite",
  "landing.manifesto.label": "Manifesto",
  "landing.manifesto.text":
    '"Bir devre <em>görüntülenmez</em>, <em>hissedilir</em>. Her elektron bir <em>yolcu</em>; rotasını <em>okumak</em> için gözlem aletine gerek vardır."',
  "landing.manifesto.sign": "— Volt × Ampere · Observatorium · MMXXVI",

  // Sidebar
  "sidebar.search.placeholder": "Sembol ara…",
  "sidebar.section.sources": "Kaynaklar",
  "sidebar.section.passive": "Pasif",
  "sidebar.section.active": "Aktif",
  "sidebar.section.connectors": "Bağlantı",
  "sidebar.empty": "Eşleşme yok",
  "sidebar.templates.heading": "Şablonlar",
  "sidebar.templates.placeholder": "Şablonlar Sprint 18'de gelecek.",

  // Canvas / Inspector placeholders
  "canvas.placeholder.title": "Canvas — Sprint 12",
  "canvas.placeholder.subtitle": "Devre çizimi sonraki sprint'te aktifleşir.",
  "inspector.placeholder.title": "Inspector — Sprint 14",
  "inspector.placeholder.subtitle": "Bileşen özellikleri burada görünecek.",

  // Inspector — Sprint 14
  "inspector.empty.title": "Hiçbir bileşen seçili değil",
  "inspector.empty.subtitle": "Bir bileşen seç veya Cmd+A ile hepsini seç.",
  "inspector.mixed.title": "Karışık seçim",
  "inspector.mixed.subtitle": "Farklı tipte bileşenler seçili — ortak parametre yok.",
  "inspector.section.params": "Parametreler",
  "inspector.section.formula": "Formül",
  "inspector.section.net": "Net",
  "inspector.section.measurements": "Canlı Ölçümler",
  // Sprint 18 Paket C C3 — action row
  "inspector.section.actions": "Eylemler",
  "inspector.action.rotate": "Döndür",
  "inspector.action.copy": "Kopyala",
  "inspector.action.delete": "Sil",

  // Sprint 18 D6 — breadcrumb
  "inspector.breadcrumb.component": "Bileşen",
  "inspector.breadcrumb.properties": "Özellikler",
  "inspector.breadcrumb.net": "Ağ",
  "inspector.breadcrumb.selection": "Seçim",

  // Sprint 18 D4 — live measurement table labels
  "inspector.measurements.empty": "Canlı veri yok — kanala probe bağlayın",
  "inspector.measurements.vrms": "RMS Gerilim",
  "inspector.measurements.vpeak": "Tepe Gerilim",
  "inspector.measurements.vpp": "Tepe-Tepe",
  "inspector.measurements.vavg": "Ortalama Gerilim",
  "inspector.measurements.vmax": "Maks. Gerilim",
  "inspector.measurements.vmin": "Min. Gerilim",
  "inspector.measurements.frequency": "Frekans",
  "inspector.measurements.period": "Periyot",
  // Sprint 34-4 — termal inspector bölümü.
  "inspector.thermal.title": "Sıcaklık",
  "inspector.thermal.noData": "Termal veri yok — devre çalıştığında görünür",
  "inspector.thermal.temperature": "Sıcaklık",
  "inspector.thermal.tMax": "Maksimum",
  "inspector.thermal.power": "Güç dissipation",
  "inspector.thermal.severity": "Yük",
  "inspector.button.runDc": "DC Çalıştır (F5)",
  "inspector.button.delete.annotation": "Annotation'ı sil",
  "inspector.label.netName": "Net adı",
  "inspector.hint.gnd": "Ground net adı değiştirilemez.",
  "inspector.dc.idle": "DC sonucu yok",
  "inspector.dc.running": "DC çalışıyor…",
  "inspector.dc.error": "DC hatası: {message}",
  "inspector.formula.missing": "Bu bileşen için formül tanımlı değil.",
  "inspector.multi.heading": "{count} bileşen seçili — ortak parametreler",
  // Param labels
  "inspector.param.resistance": "Direnç",
  "inspector.param.capacitance": "Kapasite",
  "inspector.param.inductance": "Endüktans",
  "inspector.param.voltage": "Gerilim",
  "inspector.param.frequency": "Frekans",
  "inspector.param.phase": "Faz",
  "inspector.param.amplitude": "Genlik",
  "inspector.param.tolerance": "Tolerans",
  "inspector.param.powerRating": "Güç",
  "inspector.param.saturationCurrent": "Doyum akımı",
  "inspector.param.emissionCoefficient": "Emisyon katsayısı",
  "inspector.param.forwardVoltage": "İleri gerilim",
  "inspector.param.zenerVoltage": "Zener gerilimi",
  "inspector.param.beta": "β (kazanç)",
  "inspector.param.kp": "Kp (geçiş iletkenliği)",
  "inspector.param.thresholdVoltage": "Eşik gerilimi",
  "inspector.param.channelWidth": "Kanal genişliği",
  "inspector.param.channelLength": "Kanal uzunluğu",
  "inspector.param.idss": "IDSS",
  "inspector.param.pinchOff": "Pinch-off gerilimi",
  "inspector.param.openLoopGain": "Açık döngü kazancı",
  "inspector.param.saturationVoltage": "Doyum gerilimi",
  "inspector.param.closed": "Kapalı",
  "inspector.param.wiperRatio": "Sileceğin oranı",
  "inspector.param.position": "Pozisyon",
  "inspector.param.channelMod": "Kanal modülasyonu",
  "inspector.param.sourceKind": "Kaynak türü",

  // Sprint 23 C2 — onboarding tour
  "tour.welcome.title": "VoltXAmpere'ye hoş geldin",
  "tour.welcome.body":
    "Tarayıcında açılan, LTspice doğruluğunda elektronik laboratuvarı. Birkaç adımda etrafı sana göstereyim.",
  "tour.sidebar.title": "Yan panelden bileşen seç",
  "tour.sidebar.body":
    "Soldaki sembol kütüphanesinden direnç, kapasitör, transistör — istediğini seç ve canvas'a sürükle.",
  "tour.canvas.title": "Canvas'a yerleştir",
  "tour.canvas.body":
    "Bileşenleri tıklayıp sürükleyerek devreni şekillendir. Pin'leri kabloyla bağlamak için W tuşuna bas.",
  "tour.simulate.title": "F5 ile simüle et",
  "tour.simulate.body":
    "Devren hazırsa F5 tuşuyla DC analizini başlat. Inspector tile'ları gerilim ve akımı canlı gösterir.",
  "tour.ac.title": "F6 ile AC analiz",
  "tour.ac.body":
    "Frekans davranışını görmek için F6'ya bas — Bode plot'u kazanç ve faz cevabını çizer.",
  "tour.palette.title": "Cmd+K ile her şey",
  "tour.palette.body":
    "Cmd+K (veya Ctrl+K) komut paletini açar. Yerleştirme, simülasyon, ayar — fuzzy arama ile her şeye ulaş.",
  "tour.skip": "Atla",
  "tour.next": "Sonraki",
  "tour.prev": "Önceki",
  "tour.done": "Bitir",
  "tour.reset": "Tour'u tekrar göster",

  // Sprint 23 D1+D2 — custom shortcut UI
  "settings.shortcuts.edit": "Düzenle",
  "settings.shortcuts.reset": "Sıfırla",
  "settings.shortcuts.resetAll": "Tüm değişiklikleri sıfırla",
  "settings.shortcuts.resetConfirm":
    "Tüm özelleştirilmiş kısayolları varsayılana döndürmek istiyor musun?",
  "settings.shortcuts.editPrompt":
    "Yeni kısayol kombinasyonu (örn. Mod+s, Shift+P; boş bırakırsan kısayol kaldırılır):",
  "settings.shortcuts.conflict": "{{command}} komutu üstüne yazılacak — onaylıyor musun?",
  "settings.shortcuts.overridden": "Özelleştirilmiş",
  "settings.shortcuts.disabled": "kapalı",

  // Sprint 23 D3 — OpAmp model presets
  "inspector.opamp.preset.label": "Model",
  "inspector.opamp.preset.custom": "Özel",
  "inspector.opamp.preset.ua741": "µA741",
  "inspector.opamp.preset.lm358": "LM358",
  "inspector.opamp.preset.tl072": "TL072",

  // Sprint 23 I1 — topbar save + auto-save indicator
  "topbar.save": "Kaydet",
  "topbar.autoSave.pending": "Kaydedilecek…",
  "topbar.autoSave.saving": "Kaydediliyor…",
  "topbar.autoSave.saved": "Kaydedildi",
  "topbar.autoSave.savedAt": "{{time}} kaydedildi",
  "topbar.autoSave.error": "Kayıt hatası",
  "shortcut.file.save": "Devreyi kaydet",

  // Sprint 24 A2 — Bode UX overlay
  "bode.subplot.mag": "|H(jω)| — kazanç",
  "bode.subplot.phase": "∠H(jω) — faz",
  "bode.axis.frequency": "Frekans (Hz)",
  "bode.axis.magnitude": "Kazanç",
  "bode.axis.phase": "Faz",

  // Statusbar
  "statusbar.ready": "Hazır",
  "statusbar.symbols": "{count} sembol",
  "statusbar.selection": "{count} seçili",
  "statusbar.locale": "TR",

  // Command palette
  "palette.title": "Komut Paleti",
  "palette.search": "Komut ara…",
  "palette.placeholder": "Komutlar Sprint 13'te gelecek.",
  "palette.hint": "Esc ile kapat",

  // Shortcut overlay
  "shortcuts.title": "Kısayollar",
  "shortcuts.section.global": "Genel",
  "shortcuts.section.symbols": "Semboller",
  "shortcuts.empty": "Kayıtlı kısayol yok.",
  "shortcuts.hint": "Esc ile kapat",

  // Modal generic
  "modal.close": "Kapat",

  // Shortcut descriptions
  "shortcut.palette.toggle": "Komut paleti aç/kapa",
  "shortcut.shortcuts.toggle": "Kısayol listesi",
  // Sprint 80.Y L-A-2 — osiloskop reversibility (Şefim #2 closure).
  "shortcut.view.toggleWaveformPane": "Osiloskop panelini aç/kapa",
  "shortcut.modal.close": "Modalı kapat",
  "shortcut.symbol.arm": "{name} ekle",
  // Sprint 27 Lane 2 — typecheck cleanup; canvas-catalog.ts already
  // uses these via t() but the keys had not been added to the bundles
  // (silent runtime fallback to literal key, but tsc strict TranslationKey
  // union rejected the call site).
  "shortcut.delete.describe": "Seçili öğeyi sil",
  "canvas.aria.label": "Devre tasarım kanvası",

  // Import / Export — Sprint 16
  "topbar.import": "İçe Aktar",
  "topbar.export": "Dışa Aktar",
  // Sprint 80.Y L-A-2 — osiloskop topbar toggle chip.
  "topbar.waveform.toggle.label": "Osiloskop",
  "topbar.waveform.toggle.title": "Osiloskop panelini aç/kapa (⌘⇧O)",
  "topbar.waveform.toggle.hide": "Osiloskop panelini gizle",
  "topbar.waveform.toggle.show": "Osiloskop panelini göster",
  "import.title": "SPICE Devresi İçe Aktar",
  "import.samples.label": "Örnek devreler",
  "import.paste.label": "SPICE netlist'i yapıştırın",
  "import.paste.placeholder": "* Voltage divider\nV1 vcc 0 5\nR1 vcc out 1k\nR2 out 0 1k\n.end",
  "import.button.cancel": "İptal",
  "import.button.preview": "Önizle",
  "import.button.apply": "Uygula",
  "import.preview.summary": "{components} bileşen · {nets} net · {warnings} uyarı",
  "import.error.line": "Satır {line}:{col} — {message}",
  "export.title": "SPICE Olarak Dışa Aktar",
  "export.preview.label": "SPICE çıktı (canonical Berkeley SPICE3)",
  "export.button.close": "Kapat",
  "export.button.copy": "Panoya Kopyala",
  "export.button.copied": "Kopyalandı!",
  "export.button.download": ".cir Olarak İndir",
  "export.empty": "Aktif devre yok",
  "shortcut.import.open": "İçe aktar dialog'u",
  "shortcut.export.open": "Dışa aktar dialog'u",
  "shortcut.export.clipboard": "Panoya hızlı dışa aktar",

  // Presets — Sprint 17
  "topbar.presets": "Hazır Devreler",
  "presets.title": "Hazır Devreler",
  "presets.category.all": "Tümü",
  // Sprint 18 Paket B B4 — DEVRELER page
  "presets.page.caption": "Catalogus Circuitorum",
  "presets.page.title": "Hazır <em>devreler</em>",
  "presets.page.sub":
    "Sıkça karşılaşılan referans devreler — voltaj bölücüden 555 osilatöre. Her birini aç, oku, oyna.",
  // Sprint 80.Y L-D-1 — total preset/category count badge (Şefim
  // #5/#6 discoverability closure).
  "presets.page.totalBadge": "{count} preset · {categories} kategori",
  "presets.empty": "Bu kategori henüz boş — yakında.",
  "presets.button.cancel": "İptal",
  "presets.button.load": "Yükle",
  "presets.detail.empty": "Önizleme için soldan bir devre seç.",
  "presets.expectedValues.label": "Beklenen Değerler",
  "presets.expectedValues.empty": "Bu preset için sayısal doğrulama henüz tanımlı değil.",
  "presets.learningGoals.label": "Öğrenme Hedefleri",
  "presets.references.label": "Kaynaklar",
  "shortcut.presets.open": "Hazır devreleri aç",

  // Sprint 18 Paket C C1 — Δt cursor pair
  "waveform.cursor.t1": "T1",
  "waveform.cursor.t2": "T2",
  "waveform.cursor.dt": "Δt",
  "waveform.cursor.invdt": "1/Δt",
  "waveform.cursor.toggle.title": "Δt imleçleri",
  "waveform.cursor.toggle.aria": "Δt imleçlerini aç/kapa",
  "shortcut.waveform.cursor.t1": "T1 imlecini hareket ettir",
  "shortcut.waveform.cursor.t2": "T2 imlecini hareket ettir (Shift)",

  // Sprint 18 Paket C C2 — 8/8 ölçüm tile'ları
  "waveform.measure.vrms": "V_rms",
  "waveform.measure.vpeak": "V_peak",
  "waveform.measure.vpp": "V_pp",
  "waveform.measure.frequency": "Frekans",
  "waveform.measure.period": "Periyot",
  "waveform.measure.duty": "Duty",
  "waveform.measure.deltaT": "Δt",
  "waveform.measure.invDeltaT": "1/Δt",
  "waveform.empty.title": "Probe takılı değil",
  "waveform.empty.hint": "Bir wire'a sağ tıklayıp kanala bağla.",
  // Sprint 19 F4 — probe context menu localization
  "probeMenu.netHeader": "Net: {netId}…",
  "probeMenu.bind": "{channel} kanalına bağla",
  "probeMenu.boundHere": "✓ {channel} (bu net)",
  "probeMenu.boundElsewhere": "{channel} — başka nette bağlı",
  // Sprint 25 R3 lane 4 — auto-bind to next free channel
  "probeMenu.autoBind": "★ Otomatik bağla → {channel}",
  // Sprint 20 — AC analysis tokens
  "ac.run.label": "AC analizi çalıştır (F6)",
  "ac.config.fStart": "Başlangıç frekansı (Hz)",
  "ac.config.fStop": "Bitiş frekansı (Hz)",
  "ac.config.points": "Nokta sayısı",
  "ac.config.sweep.dec": "Logaritmik (dec)",
  "ac.config.sweep.oct": "Logaritmik (oct)",
  "ac.config.sweep.lin": "Lineer",
  "ac.mode.magnitude": "Büyüklük",
  "ac.mode.phase": "Faz",
  "ac.units.linear": "Lineer",
  "ac.units.dB": "dB",
  "ac.units.deg": "°",
  "ac.units.rad": "rad",
  "ac.empty.title": "AC sonucu yok",
  "ac.empty.hint": "F6 ile AC analizini başlat.",
  "ac.errors.fStartInvalid": "Başlangıç frekansı pozitif olmalı.",
  "ac.errors.fStartGreaterEqStop": "Başlangıç < bitiş olmalı.",
  "ac.errors.pointsInvalid": "En az 2 nokta gerekli.",
  "ac.status.running": "AC çalışıyor… {points} nokta",
  "ac.status.done": "AC: {points} nokta · {ms} ms",
  // Sprint 21 C4 — URL hash share tokens
  "share.url.button": "Bağlantı paylaş",
  "share.url.copy.success": "Bağlantı panoya kopyalandı",
  "share.url.copy.fail": "Bağlantı kopyalanamadı: {reason}",
  "share.url.tooLarge.title": "Devre paylaşmak için çok büyük",
  "share.url.tooLarge.hint": ".vxa indirip paylaşın (boyut sınırsız).",
  "share.url.import.success": "Paylaşılan devre yüklendi",
  "share.url.import.fail": "Paylaşılan bağlantı çözülemedi: {reason}",
  "share.url.toast.shared": "Bağlantı kopyalandı · {bytes} byte",
  // Sprint 21 C5 — AYARLAR Veri sekmesi
  "settings.tab.data": "Veri",
  "settings.data.title": "Veri yönetimi",
  "settings.data.storage.label": "Depolama",
  "settings.data.storage.circuits": "Devre",
  "settings.data.storage.bytes": "Boyut",
  "settings.data.recents.label": "Son devreler",
  "settings.data.recents.empty": "Henüz kayıtlı devre yok.",
  "settings.data.recents.open": "Aç",
  "settings.data.recents.delete": "Sil",
  "settings.data.actions.label": "İşlemler",
  "settings.data.import.button": ".vxa içe aktar",
  "settings.data.import.success": "Devre yüklendi.",
  "settings.data.import.fail": "İçe aktarma başarısız: {reason}",
  "settings.data.clear.button": "Tümünü temizle",
  "settings.data.clear.confirm": "Tüm devre verisi silinecek. Geri alınamaz.",
  "settings.data.clear.confirm.yes": "Evet, sil",
  "settings.data.clear.confirm.no": "İptal",
  "settings.data.clear.success": "Tüm veri temizlendi.",
  // Sprint 21 C7 — AC config dialog (Sprint 20 C6 deferred)
  "ac.config.title": "AC süpürme ayarları",
  "ac.config.sweepLabel": "Süpürme tipi",
  "ac.config.run": "AC çalıştır",
  "ac.config.cancel": "İptal",

  // Sprint 22 E1 — Komut paleti (BLUEPRINT §14) yardımcı metinleri
  "palette.recent.label": "Son kullanılan",
  "palette.suggested.label": "Öneriler",
  "palette.empty.title": "Eşleşen komut yok",
  "palette.empty.hint": "Başka bir kelime dene veya Esc ile kapat.",
  "palette.executing": "Çalıştırılıyor…",
  "palette.error.notFound": "Komut bulunamadı: {id}",
  "palette.error.gated": "Bu komut bu bağlamda kullanılamaz.",
  "palette.shortcut.label": "Kısayol",

  // Sprint 22 E1 — file.* (10 komut after S80.Z Phase 4 D1 removed
  // file.saveAs; file.saveCopy retained but gated when:false)
  "command.file.save": "Devreyi kaydet",
  "command.file.save.desc": "Etkin devreyi tarayıcı belleğine yaz",
  "command.file.saveCopy": "Kopya kaydet",
  "command.file.exportVxa": ".vxa olarak dışa aktar",
  "command.file.exportVxa.desc": "Devreyi taşınabilir .vxa dosyası olarak indir",
  "command.file.importVxa": ".vxa içe aktar",
  "command.file.importVxa.desc": "Daha önce kaydedilmiş bir .vxa dosyasını aç",
  "command.file.shareUrl": "Bağlantı paylaş",
  "command.file.shareUrl.desc": "Devreyi URL hash içine sıkıştır ve panoya kopyala",
  "command.file.newEmpty": "Yeni boş devre",
  "command.file.newEmpty.desc": "Açık devreyi temizle, sıfırdan başla",
  "command.file.newFromTemplate": "Şablondan yeni",
  "command.file.newFromTemplate.desc": "Hazır devre kataloğundan başlangıç noktası seç",
  "command.file.recent.slot1": "Son devre · 1",
  "command.file.recent.slot2": "Son devre · 2",
  "command.file.recent.slot3": "Son devre · 3",

  // Sprint 22 E1 — edit.* (8 komut after S80.Z Phase 4 D1 removed
  // copy/cut/paste/duplicate/flipHorizontal/flipVertical)
  "command.edit.undo": "Geri al",
  "command.edit.undo.desc": "Son değişikliği geri al",
  "command.edit.redo": "Yeniden yap",
  "command.edit.redo.desc": "Geri alınmış değişikliği tekrar uygula",
  "command.edit.delete": "Sil",
  "command.edit.selectAll": "Tümünü seç",
  "command.edit.deselect": "Seçimi kaldır",
  "command.edit.rotate": "Döndür",
  "command.edit.rotate.desc": "Seçili bileşeni 90° saat yönünde döndür",
  "command.edit.rotateCw": "Saat yönünde döndür",
  "command.edit.rotateCcw": "Saat yönünün tersine döndür",

  // Sprint 22 E1 — view.* (12 komut)
  "command.view.zoomIn": "Yakınlaştır",
  "command.view.zoomOut": "Uzaklaştır",
  "command.view.zoomFit": "Ekrana sığdır",
  "command.view.zoomReset": "Varsayılan zoom",
  "command.view.toggleGrid": "Grid'i aç/kapa",
  "command.view.toggleSnap": "Snap'i aç/kapa",
  "command.view.toggleSnap.desc": "Bileşenler grid'e yapışır mı belirle",
  "command.view.toggleDarkMode": "Koyu mod aç/kapa",
  "command.view.toggleDarkMode.desc": "Zenit gece moduna geç (varsayılan açık)",
  "command.view.toggleFullscreen": "Tam ekran",
  "command.view.toggleInspector": "Inspector panelini aç/kapa",
  "command.view.toggleBode": "Bode plot aç/kapa",
  "command.view.toggleBode.desc": "AC analizi için Bode plot panelini göster/gizle",
  "command.view.toggleCursors": "Δt imleçleri aç/kapa",
  "command.view.toggleCursors.desc": "Waveform üzerinde T1/T2 ölçü imleçlerini aç/kapa",
  "command.view.toggleLabels": "Net etiketlerini aç/kapa",
  // Sprint 80.Y L-A-2 — palette command (Şefim #2 closure).
  "command.view.toggleWaveformPane": "Osiloskop panelini aç/kapa",
  "command.view.toggleWaveformPane.desc":
    "Alt osiloskop panelini tam gizle veya göster — Cmd+Shift+O ile aynı eylem",

  // Sprint 22 E1 — tool.* (6 komut)
  "command.tool.select": "Seçim aracı",
  "command.tool.select.desc": "Bileşenleri tıklayıp sürüklemek için ok aracına dön",
  "command.tool.wire": "Kablo aracı",
  "command.tool.wire.desc": "İki net arasına kablo çiz",
  "command.tool.probe": "Probe aracı",
  "command.tool.probe.desc": "Bir nete probe yerleştir, kanala bağla",
  "command.tool.stamp": "Stamp (yerleştir)",
  "command.tool.stamp.desc": "Sembol kütüphanesinden seçip canvas'a yerleştir",
  "command.tool.text": "Metin aracı",
  "command.tool.pan": "Pan aracı",

  // Sprint 22 E1 — place.* (20 komut, ALL_SYMBOLS sırası)
  "command.place.dc-source": "DC kaynak yerleştir",
  "command.place.dc-source.desc": "Sabit gerilim kaynağı (V₁ gibi)",
  "command.place.ac-source": "AC kaynak yerleştir",
  "command.place.ac-source.desc": "Sinüs gerilim kaynağı — AC analizinde küçük sinyal",
  "command.place.pulse-source": "Pulse kaynak yerleştir",
  "command.place.pulse-source.desc": "Kare/dijital pulse — V₁→V₂ darbe trenleri",
  // Sprint 25 R2 lane 4b — current-source UI symbol
  "command.place.current-source": "Akım kaynağı yerleştir",
  "command.place.current-source.desc": "Sabit DC akım kaynağı (I₁ gibi)",
  // Sprint 25 R2 lane 4c — pwl-source UI symbol
  "command.place.pwl-source": "PWL kaynak yerleştir",
  "command.place.pwl-source.desc": "Piecewise-linear waveform — (zaman, V) breakpoint listesi",
  "command.place.resistor": "Direnç yerleştir",
  "command.place.resistor.desc": "İki uçlu direnç (Ω)",
  "command.place.capacitor": "Kapasitör yerleştir",
  "command.place.capacitor.desc": "İki uçlu kapasitör (F)",
  "command.place.inductor": "Endüktans yerleştir",
  "command.place.inductor.desc": "İki uçlu bobin (H)",
  "command.place.potentiometer": "Potansiyometre yerleştir",
  "command.place.potentiometer.desc": "Üç uçlu ayarlı direnç (silecek oranlı)",
  "command.place.switch": "Anahtar yerleştir",
  "command.place.switch.desc": "Açık/kapalı kontrol edilebilir anahtar",
  "command.place.ground": "Ground yerleştir",
  "command.place.ground.desc": "0 V referans noktası — her devrede zorunlu",
  "command.place.wire": "Kablo yerleştir",
  "command.place.wire.desc": "İki ucu birleştiren kablo segmenti",
  "command.place.node": "Bağlantı noktası yerleştir",
  "command.place.node.desc": "Üç+ kabloyu birleştiren düğüm",
  "command.place.diode": "Diyot yerleştir",
  "command.place.diode.desc": "Tek yönlü iletim — anot → katot",
  "command.place.led": "LED yerleştir",
  "command.place.led.desc": "Işık yayan diyot — V_F ≈ 1.8…3.4 V",
  "command.place.zener": "Zener diyot yerleştir",
  "command.place.zener.desc": "Ters yönde sabit V_Z'de iletime geçer",
  "command.place.npn": "NPN transistor yerleştir",
  "command.place.npn.desc": "Bipolar NPN — Ebers-Moll, Şefim'in yükseltici taşı",
  "command.place.pnp": "PNP transistor yerleştir",
  "command.place.pnp.desc": "Bipolar PNP — NPN'nin tersi polariteli kardeşi",
  "command.place.nmos": "NMOS transistor yerleştir",
  "command.place.nmos.desc": "Shichman-Hodges N-kanal MOSFET",
  "command.place.pmos": "PMOS transistor yerleştir",
  "command.place.pmos.desc": "Shichman-Hodges P-kanal MOSFET",
  "command.place.jfet": "JFET yerleştir",
  "command.place.jfet.desc": "Junction FET — yüksek giriş empedansı",
  "command.place.op-amp": "Op-amp yerleştir",
  "command.place.op-amp.desc": "Tek kutuplu ideal/macro işlemsel yükselteç",

  // Sprint 80.X Sandık Kapağı (F-IA-101, ADR-0118) — 184 sprint 38+ datasheet variant place i18n geriçekme. script-generated via scripts/i18n/generate-variant-tokens.mjs.
  "command.place.headphone-amp": "Kulaklık Amfi (CMoy generic, placeholder)",
  "command.place.headphone-amp.desc": "Kulaklık Amfi (CMoy generic, placeholder) yerleştir",
  "command.place.lm386": "LM386 (Audio Amp 0.5W, DIP-8, placeholder)",
  "command.place.lm386.desc": "LM386 (Audio Amp 0.5W, DIP-8, placeholder) yerleştir",
  "command.place.pam8403": "PAM8403 (Class-D Stereo 2×3W, SOP-16, placeholder)",
  "command.place.pam8403.desc": "PAM8403 (Class-D Stereo 2×3W, SOP-16, placeholder) yerleştir",
  "command.place.tda2030": "TDA2030A (Audio Amp 18W, TO-220-5, placeholder)",
  "command.place.tda2030.desc": "TDA2030A (Audio Amp 18W, TO-220-5, placeholder) yerleştir",
  "command.place.tda7297": "TDA7297 (Stereo Audio Amp 2×15W, MW-15, placeholder)",
  "command.place.tda7297.desc": "TDA7297 (Stereo Audio Amp 2×15W, MW-15, placeholder) yerleştir",
  "command.place.battery-9v-alkaline": "9V Alkalin Pil (NEDA 1604)",
  "command.place.battery-9v-alkaline.desc": "9V Alkalin Pil (NEDA 1604) yerleştir",
  "command.place.2n2222": "2N2222 (NPN, TO92)",
  "command.place.2n2222.desc": "2N2222 (NPN, TO92) yerleştir",
  "command.place.2n3904": "2N3904 (NPN, TO92)",
  "command.place.2n3904.desc": "2N3904 (NPN, TO92) yerleştir",
  "command.place.bc547": "BC547 (NPN, TO92)",
  "command.place.bc547.desc": "BC547 (NPN, TO92) yerleştir",
  "command.place.2n3906": "2N3906 (PNP, TO92)",
  "command.place.2n3906.desc": "2N3906 (PNP, TO92) yerleştir",
  "command.place.bc557": "BC557 (PNP, TO92)",
  "command.place.bc557.desc": "BC557 (PNP, TO92) yerleştir",
  "command.place.buzzer-active-5v": "Aktif Piezo Buzzer 5V (yerleşik osilatör)",
  "command.place.buzzer-active-5v.desc": "Aktif Piezo Buzzer 5V (yerleşik osilatör) yerleştir",
  "command.place.buzzer-passive-5v": "Pasif Piezo Buzzer 5V (PWM kontrollü)",
  "command.place.buzzer-passive-5v.desc": "Pasif Piezo Buzzer 5V (PWM kontrollü) yerleştir",
  "command.place.dtr-rts-reset": "DTR/RTS Auto-Reset Modülü (Arduino)",
  "command.place.dtr-rts-reset.desc": "DTR/RTS Auto-Reset Modülü (Arduino) yerleştir",
  "command.place.battery-9v-clip": "9V Pil Klipsi (PP3 Snap)",
  "command.place.battery-9v-clip.desc": "9V Pil Klipsi (PP3 Snap) yerleştir",
  "command.place.alligator-clips": "Krokodil Pens Çifti (kırmızı + siyah)",
  "command.place.alligator-clips.desc": "Krokodil Pens Çifti (kırmızı + siyah) yerleştir",
  "command.place.db9-male": "DB9 Erkek (RS-232 Konektör)",
  "command.place.db9-male.desc": "DB9 Erkek (RS-232 Konektör) yerleştir",
  "command.place.din-5pin": "5-Pin DIN Konektör (audio/MIDI)",
  "command.place.din-5pin.desc": "5-Pin DIN Konektör (audio/MIDI) yerleştir",
  "command.place.icsp-header": "ICSP Header (6-pin AVR Programlama)",
  "command.place.icsp-header.desc": "ICSP Header (6-pin AVR Programlama) yerleştir",
  "command.place.jst-ph": "JST PH 2.0mm (2-pin power, schema-only)",
  "command.place.jst-ph.desc": "JST PH 2.0mm (2-pin power, schema-only) yerleştir",
  "command.place.jtag-header": "JTAG Header (10-pin Atmel ICE)",
  "command.place.jtag-header.desc": "JTAG Header (10-pin Atmel ICE) yerleştir",
  "command.place.pin-header-2.54": "Pin Header 2.54mm (single row, schema-only)",
  "command.place.pin-header-2.54.desc": "Pin Header 2.54mm (single row, schema-only) yerleştir",
  "command.place.rs232-cable": "RS-232 Null-Modem Kablo",
  "command.place.rs232-cable.desc": "RS-232 Null-Modem Kablo yerleştir",
  "command.place.screw-terminal": "Vidalı Klemens (PCB-mount, schema-only)",
  "command.place.screw-terminal.desc": "Vidalı Klemens (PCB-mount, schema-only) yerleştir",
  "command.place.usb-a": "USB-A (Type-A 4-pin, schema-only)",
  "command.place.usb-a.desc": "USB-A (Type-A 4-pin, schema-only) yerleştir",
  "command.place.usb-c": "USB-C (Type-C 24-pin, schema-only)",
  "command.place.usb-c.desc": "USB-C (Type-C 24-pin, schema-only) yerleştir",
  "command.place.crystal-16mhz": "Kristal 16 MHz (HC-49S, placeholder)",
  "command.place.crystal-16mhz.desc": "Kristal 16 MHz (HC-49S, placeholder) yerleştir",
  "command.place.crystal-32k768": "Kristal 32.768 kHz (Watch, RTC, placeholder)",
  "command.place.crystal-32k768.desc": "Kristal 32.768 kHz (Watch, RTC, placeholder) yerleştir",
  "command.place.ceramic-resonator": "Seramik Rezonatör 8 MHz (Murata CSTLS, placeholder)",
  "command.place.ceramic-resonator.desc":
    "Seramik Rezonatör 8 MHz (Murata CSTLS, placeholder) yerleştir",
  "command.place.avalanche-diode": "Avalanche Diode 100V (APD, placeholder)",
  "command.place.avalanche-diode.desc": "Avalanche Diode 100V (APD, placeholder) yerleştir",
  "command.place.photodiode-array": "Photodiode Array (Hamamatsu-class, placeholder)",
  "command.place.photodiode-array.desc":
    "Photodiode Array (Hamamatsu-class, placeholder) yerleştir",
  "command.place.tunnel-diode": "Tunnel Diode (Esaki, NDR, placeholder)",
  "command.place.tunnel-diode.desc": "Tunnel Diode (Esaki, NDR, placeholder) yerleştir",
  "command.place.p6ke6v8": "P6KE6.8A (TVS 6.8V, DO-15, placeholder)",
  "command.place.p6ke6v8.desc": "P6KE6.8A (TVS 6.8V, DO-15, placeholder) yerleştir",
  "command.place.varactor": "Varactor 1SV101 (variable cap, placeholder)",
  "command.place.varactor.desc": "Varactor 1SV101 (variable cap, placeholder) yerleştir",
  "command.place.7seg-ca": "7 Segment Display (Ortak Anot, 5161AH, placeholder)",
  "command.place.7seg-ca.desc": "7 Segment Display (Ortak Anot, 5161AH, placeholder) yerleştir",
  "command.place.7seg-cc": "7 Segment Display (Ortak Katot, 5161AS, placeholder)",
  "command.place.7seg-cc.desc": "7 Segment Display (Ortak Katot, 5161AS, placeholder) yerleştir",
  "command.place.lcd-16x2": "16x2 Karakter LCD (HD44780, placeholder)",
  "command.place.lcd-16x2.desc": "16x2 Karakter LCD (HD44780, placeholder) yerleştir",
  "command.place.lcd-20x4": "20x4 Karakter LCD (HD44780, placeholder)",
  "command.place.lcd-20x4.desc": "20x4 Karakter LCD (HD44780, placeholder) yerleştir",
  "command.place.led-matrix-8x8": "8x8 LED Matrix (1088AS, placeholder)",
  "command.place.led-matrix-8x8.desc": "8x8 LED Matrix (1088AS, placeholder) yerleştir",
  "command.place.ch340g": "CH340G (USB-UART Köprü, ekonomik)",
  "command.place.ch340g.desc": "CH340G (USB-UART Köprü, ekonomik) yerleştir",
  "command.place.cp2102": "CP2102 (USB-UART Köprü)",
  "command.place.cp2102.desc": "CP2102 (USB-UART Köprü) yerleştir",
  "command.place.ft232rl": "FT232RL (USB-UART Köprü)",
  "command.place.ft232rl.desc": "FT232RL (USB-UART Köprü) yerleştir",
  "command.place.max232": "MAX232 (TTL ↔ RS-232 Seviye Çevirici)",
  "command.place.max232.desc": "MAX232 (TTL ↔ RS-232 Seviye Çevirici) yerleştir",
  "command.place.pc817-uart": "PC817 Opto-İzole UART",
  "command.place.pc817-uart.desc": "PC817 Opto-İzole UART yerleştir",
  "command.place.2n3819": "2N3819 (JFET n-kanal, TO92)",
  "command.place.2n3819.desc": "2N3819 (JFET n-kanal, TO92) yerleştir",
  "command.place.j201": "J201 (JFET n-kanal audio, TO92)",
  "command.place.j201.desc": "J201 (JFET n-kanal audio, TO92) yerleştir",
  "command.place.led-blue-5mm": "LED Mavi 5mm (genel)",
  "command.place.led-blue-5mm.desc": "LED Mavi 5mm (genel) yerleştir",
  "command.place.led-green-5mm": "LED Yeşil 5mm (genel)",
  "command.place.led-green-5mm.desc": "LED Yeşil 5mm (genel) yerleştir",
  "command.place.led-red-5mm": "LED Kırmızı 5mm (genel)",
  "command.place.led-red-5mm.desc": "LED Kırmızı 5mm (genel) yerleştir",
  "command.place.led-white-5mm": "LED Beyaz 5mm (genel)",
  "command.place.led-white-5mm.desc": "LED Beyaz 5mm (genel) yerleştir",
  "command.place.led-yellow-5mm": "LED Sarı 5mm (genel)",
  "command.place.led-yellow-5mm.desc": "LED Sarı 5mm (genel) yerleştir",
  "command.place.4001": "4001 (4'lü NOR CMOS, DIP-14)",
  "command.place.4001.desc": "4001 (4'lü NOR CMOS, DIP-14) yerleştir",
  "command.place.4011": "4011 (4'lü NAND CMOS, DIP-14)",
  "command.place.4011.desc": "4011 (4'lü NAND CMOS, DIP-14) yerleştir",
  "command.place.4017": "4017 (Onluk Sayıcı CMOS, DIP-16, placeholder)",
  "command.place.4017.desc": "4017 (Onluk Sayıcı CMOS, DIP-16, placeholder) yerleştir",
  "command.place.4051": "4051 (8 Kanal Analog Mux CMOS, DIP-16)",
  "command.place.4051.desc": "4051 (8 Kanal Analog Mux CMOS, DIP-16) yerleştir",
  "command.place.4052": "4052 (Çift 4 Kanal Analog Mux CMOS, DIP-16)",
  "command.place.4052.desc": "4052 (Çift 4 Kanal Analog Mux CMOS, DIP-16) yerleştir",
  "command.place.4067": "4067 (16 Kanal Analog Mux CMOS, DIP-24)",
  "command.place.4067.desc": "4067 (16 Kanal Analog Mux CMOS, DIP-24) yerleştir",
  "command.place.4070": "4070 (4'lü XOR CMOS, DIP-14)",
  "command.place.4070.desc": "4070 (4'lü XOR CMOS, DIP-14) yerleştir",
  "command.place.4584": "4584 (6'lı Schmitt NOT CMOS, DIP-14)",
  "command.place.4584.desc": "4584 (6'lı Schmitt NOT CMOS, DIP-14) yerleştir",
  "command.place.7400": "7400 (4'lü NAND, DIP-14)",
  "command.place.7400.desc": "7400 (4'lü NAND, DIP-14) yerleştir",
  "command.place.7402": "7402 (4'lü NOR, DIP-14)",
  "command.place.7402.desc": "7402 (4'lü NOR, DIP-14) yerleştir",
  "command.place.7404": "7404 (6'lı NOT, DIP-14)",
  "command.place.7404.desc": "7404 (6'lı NOT, DIP-14) yerleştir",
  "command.place.7408": "7408 (4'lü AND, DIP-14)",
  "command.place.7408.desc": "7408 (4'lü AND, DIP-14) yerleştir",
  "command.place.7432": "7432 (4'lü OR, DIP-14)",
  "command.place.7432.desc": "7432 (4'lü OR, DIP-14) yerleştir",
  "command.place.7474": "7474 (Çift D Flip-Flop, DIP-14, placeholder)",
  "command.place.7474.desc": "7474 (Çift D Flip-Flop, DIP-14, placeholder) yerleştir",
  "command.place.7486": "7486 (4'lü XOR, DIP-14)",
  "command.place.7486.desc": "7486 (4'lü XOR, DIP-14) yerleştir",
  "command.place.74hc00": "74HC00 (4'lü NAND CMOS, DIP-14)",
  "command.place.74hc00.desc": "74HC00 (4'lü NAND CMOS, DIP-14) yerleştir",
  "command.place.74hc04": "74HC04 (6'lı NOT CMOS, DIP-14)",
  "command.place.74hc04.desc": "74HC04 (6'lı NOT CMOS, DIP-14) yerleştir",
  "command.place.74hc08": "74HC08 (4'lü AND CMOS, DIP-14)",
  "command.place.74hc08.desc": "74HC08 (4'lü AND CMOS, DIP-14) yerleştir",
  "command.place.74hc132": "74HC132 (4'lü Schmitt NAND, DIP-14)",
  "command.place.74hc132.desc": "74HC132 (4'lü Schmitt NAND, DIP-14) yerleştir",
  "command.place.74hc14": "74HC14 (6'lı Schmitt NOT, DIP-14)",
  "command.place.74hc14.desc": "74HC14 (6'lı Schmitt NOT, DIP-14) yerleştir",
  "command.place.74hc4051": "74HC4051 (8 Kanal Analog Mux CMOS Hızlı, DIP-16)",
  "command.place.74hc4051.desc": "74HC4051 (8 Kanal Analog Mux CMOS Hızlı, DIP-16) yerleştir",
  "command.place.74hc74": "74HC74 (Çift D Flip-Flop CMOS, DIP-14, placeholder)",
  "command.place.74hc74.desc": "74HC74 (Çift D Flip-Flop CMOS, DIP-14, placeholder) yerleştir",
  "command.place.magnetic-cm-choke": "Common-Mode Choke (Würth WE-CMB, placeholder)",
  "command.place.magnetic-cm-choke.desc": "Common-Mode Choke (Würth WE-CMB, placeholder) yerleştir",
  "command.place.adafruit-feather": "Adafruit Feather (ESP32/SAMD21, USB-C, placeholder)",
  "command.place.adafruit-feather.desc":
    "Adafruit Feather (ESP32/SAMD21, USB-C, placeholder) yerleştir",
  "command.place.arduino-nano": "Arduino Nano (ATmega328P, USB-mini)",
  "command.place.arduino-nano.desc": "Arduino Nano (ATmega328P, USB-mini) yerleştir",
  "command.place.arduino-uno-r3": "Arduino UNO R3 (ATmega328P, USB-B)",
  "command.place.arduino-uno-r3.desc": "Arduino UNO R3 (ATmega328P, USB-B) yerleştir",
  "command.place.atmega2560": "ATmega2560 (Arduino Mega, TQFP-100)",
  "command.place.atmega2560.desc": "ATmega2560 (Arduino Mega, TQFP-100) yerleştir",
  "command.place.atmega328p": "ATmega328P (Arduino UNO, DIP-28)",
  "command.place.atmega328p.desc": "ATmega328P (Arduino UNO, DIP-28) yerleştir",
  "command.place.attiny84": "ATtiny84 (DIP-14, placeholder)",
  "command.place.attiny84.desc": "ATtiny84 (DIP-14, placeholder) yerleştir",
  "command.place.attiny85": "ATtiny85 (DIP-8)",
  "command.place.attiny85.desc": "ATtiny85 (DIP-8) yerleştir",
  "command.place.breakout-dip28": "DIP-28 Breakout (ATmega328P/168 bare chip, placeholder)",
  "command.place.breakout-dip28.desc":
    "DIP-28 Breakout (ATmega328P/168 bare chip, placeholder) yerleştir",
  "command.place.breakout-dip40": "DIP-40 Breakout (ATmega2560/1284 bare chip, placeholder)",
  "command.place.breakout-dip40.desc":
    "DIP-40 Breakout (ATmega2560/1284 bare chip, placeholder) yerleştir",
  "command.place.esp32-wroom-32": "ESP32-WROOM-32 (Modül, placeholder)",
  "command.place.esp32-wroom-32.desc": "ESP32-WROOM-32 (Modül, placeholder) yerleştir",
  "command.place.esp8266": "ESP8266 (NodeMCU, placeholder)",
  "command.place.esp8266.desc": "ESP8266 (NodeMCU, placeholder) yerleştir",
  "command.place.rp2040": "RP2040 (Raspberry Pi Pico, QFN-56, placeholder)",
  "command.place.rp2040.desc": "RP2040 (Raspberry Pi Pico, QFN-56, placeholder) yerleştir",
  "command.place.sparkfun-pro-micro": "Sparkfun Pro Micro (ATmega32U4, USB-HID, placeholder)",
  "command.place.sparkfun-pro-micro.desc":
    "Sparkfun Pro Micro (ATmega32U4, USB-HID, placeholder) yerleştir",
  "command.place.stm32-blue-pill": "STM32 Blue Pill (STM32F103C8, ARM Cortex-M3, placeholder)",
  "command.place.stm32-blue-pill.desc":
    "STM32 Blue Pill (STM32F103C8, ARM Cortex-M3, placeholder) yerleştir",
  "command.place.stm32f103c8": "STM32F103C8 (Blue Pill, LQFP-48, placeholder)",
  "command.place.stm32f103c8.desc": "STM32F103C8 (Blue Pill, LQFP-48, placeholder) yerleştir",
  "command.place.24lc256": "24LC256 (I2C EEPROM 256Kbit, DIP-8, placeholder)",
  "command.place.24lc256.desc": "24LC256 (I2C EEPROM 256Kbit, DIP-8, placeholder) yerleştir",
  "command.place.25lc080": "25LC080 (SPI EEPROM 8Kbit, DIP-8, placeholder)",
  "command.place.25lc080.desc": "25LC080 (SPI EEPROM 8Kbit, DIP-8, placeholder) yerleştir",
  "command.place.ds1307": "DS1307 (I2C RTC, DIP-8, placeholder)",
  "command.place.ds1307.desc": "DS1307 (I2C RTC, DIP-8, placeholder) yerleştir",
  "command.place.m48t02": "M48T02 (NVRAM 16Kbit + RTC, DIP-24, placeholder)",
  "command.place.m48t02.desc": "M48T02 (NVRAM 16Kbit + RTC, DIP-24, placeholder) yerleştir",
  "command.place.w25q128": "W25Q128 (SPI Flash 128Mbit, SOIC-8, placeholder)",
  "command.place.w25q128.desc": "W25Q128 (SPI Flash 128Mbit, SOIC-8, placeholder) yerleştir",
  "command.place.2n7000": "2N7000 (NMOS, TO92)",
  "command.place.2n7000.desc": "2N7000 (NMOS, TO92) yerleştir",
  "command.place.bss138": "BSS138 (NMOS lojik, SOT23)",
  "command.place.bss138.desc": "BSS138 (NMOS lojik, SOT23) yerleştir",
  "command.place.irf540": "IRF540 (NMOS güç, TO220)",
  "command.place.irf540.desc": "IRF540 (NMOS güç, TO220) yerleştir",
  "command.place.irf9540": "IRF9540 (PMOS güç, TO220)",
  "command.place.irf9540.desc": "IRF9540 (PMOS güç, TO220) yerleştir",
  "command.place.motor-bldc": "BLDC Motor 12V (3-phase, placeholder)",
  "command.place.motor-bldc.desc": "BLDC Motor 12V (3-phase, placeholder) yerleştir",
  "command.place.motor-dc": "DC Motor 12V (placeholder, winding only)",
  "command.place.motor-dc.desc": "DC Motor 12V (placeholder, winding only) yerleştir",
  "command.place.motor-servo-sg90": "Servo SG90 (PWM, 5V, placeholder)",
  "command.place.motor-servo-sg90.desc": "Servo SG90 (PWM, 5V, placeholder) yerleştir",
  "command.place.motor-stepper-28byj48": "Stepper 28BYJ-48 (5V, 4-phase, placeholder)",
  "command.place.motor-stepper-28byj48.desc":
    "Stepper 28BYJ-48 (5V, 4-phase, placeholder) yerleştir",
  "command.place.ina126": "INA126 (Hassas Diferansiyel, DIP-8)",
  "command.place.ina126.desc": "INA126 (Hassas Diferansiyel, DIP-8) yerleştir",
  "command.place.lm324": "LM324 (Quad, DIP-14)",
  "command.place.lm324.desc": "LM324 (Quad, DIP-14) yerleştir",
  "command.place.lm339": "LM339 (4'lü Karşılaştırıcı, DIP-14)",
  "command.place.lm339.desc": "LM339 (4'lü Karşılaştırıcı, DIP-14) yerleştir",
  "command.place.lm358": "LM358 (Genel-Amaçlı, DIP-8)",
  "command.place.lm358.desc": "LM358 (Genel-Amaçlı, DIP-8) yerleştir",
  "command.place.lm393": "LM393 (Karşılaştırıcı, DIP-8)",
  "command.place.lm393.desc": "LM393 (Karşılaştırıcı, DIP-8) yerleştir",
  "command.place.ne5532": "NE5532 (Ses-Sınıfı, DIP-8)",
  "command.place.ne5532.desc": "NE5532 (Ses-Sınıfı, DIP-8) yerleştir",
  "command.place.opa2134": "OPA2134 (Yüksek-Sınıf Ses, DIP-8)",
  "command.place.opa2134.desc": "OPA2134 (Yüksek-Sınıf Ses, DIP-8) yerleştir",
  "command.place.tl072": "TL072 (FET-Girişli, DIP-8)",
  "command.place.tl072.desc": "TL072 (FET-Girişli, DIP-8) yerleştir",
  "command.place.tl082": "TL082 (FET-Girişli, Düşük Voltaj, DIP-8)",
  "command.place.tl082.desc": "TL082 (FET-Girişli, Düşük Voltaj, DIP-8) yerleştir",
  "command.place.4n25": "4N25 (Optocoupler 6-pin DIP, CTR 20%, placeholder)",
  "command.place.4n25.desc": "4N25 (Optocoupler 6-pin DIP, CTR 20%, placeholder) yerleştir",
  "command.place.6n137": "6N137 (Yüksek Hız Opto 10Mbit/s, DIP-8, placeholder)",
  "command.place.6n137.desc": "6N137 (Yüksek Hız Opto 10Mbit/s, DIP-8, placeholder) yerleştir",
  "command.place.pc817": "PC817 (Opto Sharp, DIP-4, CTR 50%, placeholder)",
  "command.place.pc817.desc": "PC817 (Opto Sharp, DIP-4, CTR 50%, placeholder) yerleştir",
  "command.place.tlp521": "TLP521 (Quad Opto Toshiba, DIP-16, placeholder)",
  "command.place.tlp521.desc": "TLP521 (Quad Opto Toshiba, DIP-16, placeholder) yerleştir",
  "command.place.multi-turn-pot-25": "Multi-Turn Potansiyometre (25-tur, ince ayar)",
  "command.place.multi-turn-pot-25.desc": "Multi-Turn Potansiyometre (25-tur, ince ayar) yerleştir",
  "command.place.trim-pot-10t": "Trim Potansiyometre (10-tur, hassas)",
  "command.place.trim-pot-10t.desc": "Trim Potansiyometre (10-tur, hassas) yerleştir",
  "command.place.trim-pot-1t": "Trim Potansiyometre (tek-tur, hızlı ayar)",
  "command.place.trim-pot-1t.desc": "Trim Potansiyometre (tek-tur, hızlı ayar) yerleştir",
  "command.place.tip120": "TIP120 (NPN Darlington, 60V/5A, TO-220)",
  "command.place.tip120.desc": "TIP120 (NPN Darlington, 60V/5A, TO-220) yerleştir",
  "command.place.tip125": "TIP125 (PNP Darlington, 60V/5A, TO-220)",
  "command.place.tip125.desc": "TIP125 (PNP Darlington, 60V/5A, TO-220) yerleştir",
  "command.place.db3": "DB3 (DIAC ±32V, DO-35, placeholder)",
  "command.place.db3.desc": "DB3 (DIAC ±32V, DO-35, placeholder) yerleştir",
  "command.place.irg4pc50ud": "IRG4PC50UD (IGBT 600V/27A, TO-247, placeholder)",
  "command.place.irg4pc50ud.desc": "IRG4PC50UD (IGBT 600V/27A, TO-247, placeholder) yerleştir",
  "command.place.irfp240": "IRFP240 (NMOS güç, 200V/20A, TO247)",
  "command.place.irfp240.desc": "IRFP240 (NMOS güç, 200V/20A, TO247) yerleştir",
  "command.place.c106": "C106M (SCR 600V/4A, TO-126, placeholder)",
  "command.place.c106.desc": "C106M (SCR 600V/4A, TO-126, placeholder) yerleştir",
  "command.place.bta16": "BTA16-600B (TRIAC 600V/16A, TO-220, placeholder)",
  "command.place.bta16.desc": "BTA16-600B (TRIAC 600V/16A, TO-220, placeholder) yerleştir",
  "command.place.lm4040-10v": "LM4040-10.0 (Hassas Referans 10V, SOT-23)",
  "command.place.lm4040-10v.desc": "LM4040-10.0 (Hassas Referans 10V, SOT-23) yerleştir",
  "command.place.lm4040-2v5": "LM4040-2.5 (Hassas Referans 2.5V, SOT-23)",
  "command.place.lm4040-2v5.desc": "LM4040-2.5 (Hassas Referans 2.5V, SOT-23) yerleştir",
  "command.place.lm4040-5v": "LM4040-5.0 (Hassas Referans 5.0V, SOT-23)",
  "command.place.lm4040-5v.desc": "LM4040-5.0 (Hassas Referans 5.0V, SOT-23) yerleştir",
  "command.place.tl431": "TL431 (Ayarlanabilir Şönt Regülatör, TO-92)",
  "command.place.tl431.desc": "TL431 (Ayarlanabilir Şönt Regülatör, TO-92) yerleştir",
  "command.place.zr285": "ZR285 (Düşük Güç Referans 2.85V, TO-92)",
  "command.place.zr285.desc": "ZR285 (Düşük Güç Referans 2.85V, TO-92) yerleştir",
  "command.place.7805": "7805 (+5V Sabit, TO-220)",
  "command.place.7805.desc": "7805 (+5V Sabit, TO-220) yerleştir",
  "command.place.7812": "7812 (+12V Sabit, TO-220)",
  "command.place.7812.desc": "7812 (+12V Sabit, TO-220) yerleştir",
  "command.place.7905": "7905 (-5V Sabit, TO-220)",
  "command.place.7905.desc": "7905 (-5V Sabit, TO-220) yerleştir",
  "command.place.ams1117-3v3": "AMS1117-3.3 (+3.3V LDO, SOT-223)",
  "command.place.ams1117-3v3.desc": "AMS1117-3.3 (+3.3V LDO, SOT-223) yerleştir",
  "command.place.ams1117-5v": "AMS1117-5.0 (+5V LDO, SOT-223)",
  "command.place.ams1117-5v.desc": "AMS1117-5.0 (+5V LDO, SOT-223) yerleştir",
  "command.place.lm2596": "LM2596 (Buck Anahtarlamalı +5V, TO-220)",
  "command.place.lm2596.desc": "LM2596 (Buck Anahtarlamalı +5V, TO-220) yerleştir",
  "command.place.lm317": "LM317 (Ayarlanabilir +5V, TO-220)",
  "command.place.lm317.desc": "LM317 (Ayarlanabilir +5V, TO-220) yerleştir",
  "command.place.lm337": "LM337 (Ayarlanabilir -5V, TO-220)",
  "command.place.lm337.desc": "LM337 (Ayarlanabilir -5V, TO-220) yerleştir",
  "command.place.mp1584": "MP1584 (Buck Anahtarlamalı +5V, SOIC-8)",
  "command.place.mp1584.desc": "MP1584 (Buck Anahtarlamalı +5V, SOIC-8) yerleştir",
  "command.place.relay-dpdt-12v": "Röle DPDT 12V Coil (Omron MY2N-D2, placeholder)",
  "command.place.relay-dpdt-12v.desc": "Röle DPDT 12V Coil (Omron MY2N-D2, placeholder) yerleştir",
  "command.place.relay-reed": "Reed Relay (Hamlin HE721A, placeholder)",
  "command.place.relay-reed.desc": "Reed Relay (Hamlin HE721A, placeholder) yerleştir",
  "command.place.relay-spdt-5v": "Röle SPDT 5V Coil (Omron G5LE-1-5DC, placeholder)",
  "command.place.relay-spdt-5v.desc": "Röle SPDT 5V Coil (Omron G5LE-1-5DC, placeholder) yerleştir",
  "command.place.relay-ssr": "Solid-State Röle (Omron G3MB-202P, placeholder)",
  "command.place.relay-ssr.desc": "Solid-State Röle (Omron G3MB-202P, placeholder) yerleştir",
  "command.place.resistor-10w": "Direnç 10W (aluminum-clad)",
  "command.place.resistor-10w.desc": "Direnç 10W (aluminum-clad) yerleştir",
  "command.place.resistor-5w": "Direnç 5W (wirewound)",
  "command.place.resistor-5w.desc": "Direnç 5W (wirewound) yerleştir",
  "command.place.2n5109": "2N5109 (RF Amp NPN 1.2GHz, TO-39, placeholder)",
  "command.place.2n5109.desc": "2N5109 (RF Amp NPN 1.2GHz, TO-39, placeholder) yerleştir",
  "command.place.rf-antenna": "RF Antenna (generic, placeholder)",
  "command.place.rf-antenna.desc": "RF Antenna (generic, placeholder) yerleştir",
  "command.place.bfg520": "BFG520 (RF NPN 9GHz, SOT-143, placeholder)",
  "command.place.bfg520.desc": "BFG520 (RF NPN 9GHz, SOT-143, placeholder) yerleştir",
  "command.place.rf-inductor-high-q": "RF İnduktör High-Q 100nH (Coilcraft-class)",
  "command.place.rf-inductor-high-q.desc": "RF İnduktör High-Q 100nH (Coilcraft-class) yerleştir",
  "command.place.rf-mixer": "RF Mixer (DBM, placeholder)",
  "command.place.rf-mixer.desc": "RF Mixer (DBM, placeholder) yerleştir",
  "command.place.1n5817": "1N5817 (Schottky 1A, DO41)",
  "command.place.1n5817.desc": "1N5817 (Schottky 1A, DO41) yerleştir",
  "command.place.1n5819": "1N5819 (Schottky 1A 40V, DO41)",
  "command.place.1n5819.desc": "1N5819 (Schottky 1A 40V, DO41) yerleştir",
  "command.place.bc547-photo": "BC547 + LED (Ev Yapımı Fototransistör, placeholder)",
  "command.place.bc547-photo.desc": "BC547 + LED (Ev Yapımı Fototransistör, placeholder) yerleştir",
  "command.place.bme680": "BME680 (4-in-1 Çevre Sensörü, I2C, placeholder)",
  "command.place.bme680.desc": "BME680 (4-in-1 Çevre Sensörü, I2C, placeholder) yerleştir",
  "command.place.bmp180": "BMP180 (I2C Barometrik, klasik, placeholder)",
  "command.place.bmp180.desc": "BMP180 (I2C Barometrik, klasik, placeholder) yerleştir",
  "command.place.bmp280": "BMP280 (I2C Barometrik Basınç Sensörü)",
  "command.place.bmp280.desc": "BMP280 (I2C Barometrik Basınç Sensörü) yerleştir",
  "command.place.bpw34": "BPW34 (Si PIN Fotodiyot, görünür+NIR, placeholder)",
  "command.place.bpw34.desc": "BPW34 (Si PIN Fotodiyot, görünür+NIR, placeholder) yerleştir",
  "command.place.dht11": "DHT11 (Nem + Sıcaklık Sensörü, placeholder)",
  "command.place.dht11.desc": "DHT11 (Nem + Sıcaklık Sensörü, placeholder) yerleştir",
  "command.place.dht22": "DHT22 / AM2302 (Hassas Nem + Sıcaklık, placeholder)",
  "command.place.dht22.desc": "DHT22 / AM2302 (Hassas Nem + Sıcaklık, placeholder) yerleştir",
  "command.place.ds18b20": "DS18B20 (OneWire Dijital Sıcaklık Sensörü, placeholder)",
  "command.place.ds18b20.desc": "DS18B20 (OneWire Dijital Sıcaklık Sensörü, placeholder) yerleştir",
  "command.place.ds3231": "DS3231 (I2C RTC, TCXO ±2ppm)",
  "command.place.ds3231.desc": "DS3231 (I2C RTC, TCXO ±2ppm) yerleştir",
  "command.place.hc-sr04": "HC-SR04 (Ultrasonic Mesafe Sensörü)",
  "command.place.hc-sr04.desc": "HC-SR04 (Ultrasonic Mesafe Sensörü) yerleştir",
  "command.place.ldr-7mm": "Foto-Direnç 7mm (LDR, hobi)",
  "command.place.ldr-7mm.desc": "Foto-Direnç 7mm (LDR, hobi) yerleştir",
  "command.place.ldr": "LDR (CdS Foto Direnç, GL5528)",
  "command.place.ldr.desc": "LDR (CdS Foto Direnç, GL5528) yerleştir",
  "command.place.lm35": "LM35 (Doğrusal Sıcaklık Sensörü, 10mV/°C)",
  "command.place.lm35.desc": "LM35 (Doğrusal Sıcaklık Sensörü, 10mV/°C) yerleştir",
  "command.place.mpu6050": "MPU6050 (6-axis IMU, I2C, placeholder)",
  "command.place.mpu6050.desc": "MPU6050 (6-axis IMU, I2C, placeholder) yerleştir",
  "command.place.mq-2": "MQ-2 (Gaz Sensörü, LPG/Propan/Metan/Duman)",
  "command.place.mq-2.desc": "MQ-2 (Gaz Sensörü, LPG/Propan/Metan/Duman) yerleştir",
  "command.place.ntc-10k": "NTC 10K (Beta=3950, sıcaklık sensörü)",
  "command.place.ntc-10k.desc": "NTC 10K (Beta=3950, sıcaklık sensörü) yerleştir",
  "command.place.ptc": "PTC (pozitif sıcaklık katsayılı, koruma)",
  "command.place.ptc.desc": "PTC (pozitif sıcaklık katsayılı, koruma) yerleştir",
  "command.place.tcrt5000": "TCRT5000 (Yansıtıcı IR Optik Sensör, placeholder)",
  "command.place.tcrt5000.desc": "TCRT5000 (Yansıtıcı IR Optik Sensör, placeholder) yerleştir",
  "command.place.tsl2561": "TSL2561 (I2C Ambiyans Işık Sensörü)",
  "command.place.tsl2561.desc": "TSL2561 (I2C Ambiyans Işık Sensörü) yerleştir",
  "command.place.solar-panel-5v": "Güneş Paneli 5V/100mA (Hobby)",
  "command.place.solar-panel-5v.desc": "Güneş Paneli 5V/100mA (Hobby) yerleştir",
  "command.place.switch-dip-4": "DIP Switch 4-pos (placeholder, single channel)",
  "command.place.switch-dip-4.desc": "DIP Switch 4-pos (placeholder, single channel) yerleştir",
  "command.place.switch-dpdt": "DPDT Toggle (6 terminal, placeholder)",
  "command.place.switch-dpdt.desc": "DPDT Toggle (6 terminal, placeholder) yerleştir",
  "command.place.switch-push-button": "Push Button (NO Momentary)",
  "command.place.switch-push-button.desc": "Push Button (NO Momentary) yerleştir",
  "command.place.reed-switch-magnetic": "Reed Anahtar (mıknatıs ile)",
  "command.place.reed-switch-magnetic.desc": "Reed Anahtar (mıknatıs ile) yerleştir",
  "command.place.switch-spdt": "SPDT Toggle (3 terminal, placeholder)",
  "command.place.switch-spdt.desc": "SPDT Toggle (3 terminal, placeholder) yerleştir",
  "command.place.switch-tactile": "Tactile Switch (PCB-mount, B3F serisi)",
  "command.place.switch-tactile.desc": "Tactile Switch (PCB-mount, B3F serisi) yerleştir",
  "command.place.transformer-audio-1to1": "Audio Transformer 1:1 (placeholder, primary)",
  "command.place.transformer-audio-1to1.desc":
    "Audio Transformer 1:1 (placeholder, primary) yerleştir",
  "command.place.transformer-center-tapped": "Center-Tapped Trafo 12-0-12V (placeholder, primary)",
  "command.place.transformer-center-tapped.desc":
    "Center-Tapped Trafo 12-0-12V (placeholder, primary) yerleştir",
  "command.place.transformer-power-220-12": "Güç Transformer 220V:12V (placeholder, primary)",
  "command.place.transformer-power-220-12.desc":
    "Güç Transformer 220V:12V (placeholder, primary) yerleştir",
  "command.place.1n4733": "1N4733 (Zener 5.1V, DO41)",
  "command.place.1n4733.desc": "1N4733 (Zener 5.1V, DO41) yerleştir",
  "command.place.1n4742": "1N4742 (Zener 12V, DO41)",
  "command.place.1n4742.desc": "1N4742 (Zener 12V, DO41) yerleştir",
  "command.place.1n4751": "1N4751 (Zener 30V, DO41)",
  "command.place.1n4751.desc": "1N4751 (Zener 30V, DO41) yerleştir",

  // Sprint 22 E1 — sim.* (9 komut)
  "command.sim.runDc": "DC çalıştır (F5)",
  "command.sim.runDc.desc": "Operasyon noktası — Newton-Raphson çözümü",
  "command.sim.runTransient": "Transient çalıştır",
  "command.sim.runTransient.desc": "Zamana bağlı çözüm — adaptif step",
  "command.sim.runAc": "AC çalıştır (F6)",
  "command.sim.runAc.desc": "Frekans süpürmesi — Bode plot için",
  "command.sim.toggleLive": "Live transient aç/kapa",
  "command.sim.toggleLive.desc": "Devre değişince otomatik yeniden çöz",
  "command.sim.stop": "Simülasyonu durdur",
  "command.sim.reset": "Sonuçları temizle",
  "command.sim.reset.desc": "DC/transient/AC çıktılarını sıfırla — devre korunur",
  "command.sim.configAc": "AC ayarlarını aç…",
  "command.sim.configAc.desc": "Başlangıç/bitiş frekansı, nokta sayısı, süpürme tipi",
  "command.sim.configTransient": "Transient ayarlarını aç…",
  // Sprint 80.Z Phase 4 D1 — command.sim.exportResults removed
  // (CSV / JSON export pipeline not wired; re-lands with the
  // export flow).

  // Sprint 22 E1 — pane.* (6 komut)
  "command.pane.landing": "Açılış sayfasına geç",
  "command.pane.simulator": "Simülatöre geç",
  "command.pane.presets": "Hazır devrelere geç",
  "command.pane.presets.desc": "DEVRELER kataloğunu aç (Cmd+Shift+P)",
  "command.pane.inspector": "Inspector sayfasına geç",
  "command.pane.settings": "Ayarlara geç",
  "command.pane.shortcutsOverlay": "Kısayol listesini aç",
  "command.pane.shortcutsOverlay.desc": "Tüm klavye kısayollarını tek panelde göster (?)",

  // Sprint 22 E1 — preset.* (15 komut, ALL_PRESETS sırası)
  "command.preset.voltage-divider": "Voltaj bölücü",
  "command.preset.voltage-divider.desc": "İki direnç + kaynak — temel öğretici devre",
  "command.preset.rc-low-pass": "RC alçak geçiren filtre",
  "command.preset.rc-low-pass.desc": "Birinci dereceden RC LP — fc=1/(2πRC)",
  "command.preset.rc-high-pass": "RC yüksek geçiren filtre",
  "command.preset.rc-high-pass.desc": "Birinci dereceden RC HP — DC blok, AC geç",
  "command.preset.led-current-limiter": "LED akım sınırlayıcı",
  "command.preset.led-current-limiter.desc": "Seri direnç ile LED — akım sabitleme klasiği",
  "command.preset.rl-circuit": "RL devresi",
  "command.preset.rl-circuit.desc": "Direnç + bobin — endüktif zaman sabiti τ=L/R",
  "command.preset.rlc-series-resonance": "RLC seri rezonans",
  "command.preset.rlc-series-resonance.desc": "Tank devresi — f₀=1/(2π√LC), Q=ωL/R",
  "command.preset.diode-clipper": "Diyot kırpıcı",
  "command.preset.diode-clipper.desc": "Çift diyot ile sinüsü ±V_F'de kırp",
  "command.preset.bridge-rectifier": "Köprü doğrultucu",
  "command.preset.bridge-rectifier.desc": "Dört diyot — AC'yi tam dalga DC'ye çevir",
  "command.preset.npn-common-emitter": "NPN yükselteç (CE)",
  "command.preset.npn-common-emitter.desc": "Klasik bipolar yükselteç — Rb/Rc/Re",
  "command.preset.opamp-non-inverting": "Op-amp non-inverting",
  "command.preset.opamp-non-inverting.desc": "Pozitif kazanç A=1+R_f/R_g",
  "command.preset.opamp-inverting": "Op-amp inverting",
  "command.preset.opamp-inverting.desc": "Negatif kazanç A=−R_f/R_g",
  "command.preset.opamp-buffer": "Op-amp buffer (unity)",
  "command.preset.opamp-buffer.desc": "Kazanç=1, empedans uyumu için izolasyon",
  // Sprint 25 R2 lane 6 — eksik token (S25-GAP-6 closure)
  "command.preset.opamp-astable": "Op-amp astable osilatör",
  "command.preset.opamp-astable.desc":
    "Schmitt tetiklemeli kare dalga jeneratörü — RC tau ile period",
  "command.preset.transistor-switch": "Transistor anahtar",
  "command.preset.transistor-switch.desc": "BJT'yi saturation modunda röle gibi kullan",
  "command.preset.nmos-switch": "NMOS anahtar",
  "command.preset.nmos-switch.desc": "Logic-level anahtar — gate kontrol",
  "command.preset.zener-regulator": "Zener gerilim regülatörü",
  "command.preset.zener-regulator.desc": "Sabit V_Z çıkışı — basit shunt regülatör",

  // Sprint 80.X Sandık Kapağı (F-IA-100, ADR-0118) — 15 sprint 50-2/3/4/5/6 + sprint 54.3 preset i18n geriçekme.
  // Beginner expansion (Sprint 50-2).
  "command.preset.simple-resistor-pair": "Basit direnç çifti",
  "command.preset.simple-resistor-pair.desc": "İki seri direnç — Ohm yasası temel öğretici",
  "command.preset.parallel-resistors": "Paralel dirençler",
  "command.preset.parallel-resistors.desc": "İki paralel direnç — R_eq=R₁·R₂/(R₁+R₂)",
  "command.preset.three-resistor-divider": "Üç dirençli bölücü",
  "command.preset.three-resistor-divider.desc": "Üç seri direnç — kademe bölücü topolojisi",
  // Power expansion (Sprint 50-3).
  "command.preset.half-wave-rectifier": "Yarım dalga doğrultucu",
  "command.preset.half-wave-rectifier.desc": "Tek diyot — AC'nin pozitif yarısını geçir",
  "command.preset.voltage-doubler": "Gerilim ikiyele",
  "command.preset.voltage-doubler.desc": "Cockcroft-Walton — 2 kapasitör + 2 diyot ile 2× DC",
  "command.preset.rc-power-decoupling": "Güç hat decoupling kapasitörü",
  "command.preset.rc-power-decoupling.desc":
    "Beslemeye paralel kapasitör — high-freq gürültü süzme",
  // Filter + oscillator expansion (Sprint 50-4).
  "command.preset.rc-bandpass": "RC bant geçiren filtre",
  "command.preset.rc-bandpass.desc": "HP + LP kaskat — f₁<f<f₂ bandını geçir",
  "command.preset.wien-bridge-osc": "Wien köprüsü osilatörü",
  "command.preset.wien-bridge-osc.desc": "Op-amp + RC köprü — düşük distorsiyon sinüs üretir",
  "command.preset.rc-phase-shift-osc": "RC faz kaydırma osilatörü",
  "command.preset.rc-phase-shift-osc.desc":
    "3 katlı RC ladder — 180° faz + transistör amplifikatör",
  // Logic expansion (Sprint 50-5).
  "command.preset.digital-and-gate": "AND mantık kapısı (7408)",
  "command.preset.digital-and-gate.desc": "İki girişli AND — Q=A·B doğruluk tablosu",
  "command.preset.digital-not-gate": "NOT mantık kapısı (7404)",
  "command.preset.digital-not-gate.desc": "Tek girişli inverter — Q=¬A",
  "command.preset.digital-xor-gate": "XOR mantık kapısı (7486)",
  "command.preset.digital-xor-gate.desc": "İki girişli XOR — Q=A⊕B fark detektör",
  // MCU expansion (Sprint 50-6).
  "command.preset.arduino-blink-led": "Arduino LED yanıp söndür",
  "command.preset.arduino-blink-led.desc": "ATmega328P + LED + 220Ω — delay loop hello-world",
  "command.preset.arduino-button-input": "Arduino buton girişi",
  "command.preset.arduino-button-input.desc": "Pull-up direnç + buton + ATmega328P pin oku",
  // Father's circuit (Sprint 54.3, VISION §10 50+ component regression).
  "command.preset.fathers-cap-bank-controller": "Babanın kapasitör bank kontrolcüsü",
  "command.preset.fathers-cap-bank-controller.desc":
    "VISION §10 babanın devresi — 50+ bileşen kanonik test",

  // Sprint 22 E1 — help.* (3 komut)
  "command.help.shortcuts": "Klavye kısayolları",
  "command.help.shortcuts.desc": "Tüm shortcut'ları liste halinde göster",
  "command.help.about": "Hakkında",
  "command.help.about.desc": "Sürüm, lisans, stüdyo bilgisi",
  "command.help.github": "GitHub deposu",
  "command.help.github.desc": "Kaynak kodu yeni sekmede aç",

  // Sprint 22 E1 — dev.* (5 komut, sadece ?debug=1 modunda görünür)
  "command.dev.dumpCircuit": "Geliştirici · devreyi konsola yaz",
  "command.dev.dumpCircuit.desc": "currentCircuit sinyalini JSON olarak konsola dök",
  "command.dev.clearStorage": "Geliştirici · IDB'yi temizle",
  "command.dev.clearStorage.desc": "Tüm kayıtlı devreleri ve son kullanılan komutları sil",
  "command.dev.toggleBench": "Geliştirici · perf overlay aç/kapa",
  "command.dev.toggleBench.desc": "FPS, frame time, solver ms ölçümlerini göster",
  "command.dev.logRecent": "Geliştirici · son komutları logla",
  "command.dev.replayBoot": "Geliştirici · boot'u tekrar oynat",
  "command.dev.replayBoot.desc": "Sayfayı yeniden yükle, açılış akışını yeniden çalıştır",

  // Sprint 25 R2 lane 1 — toast notification stack (TS-007)
  "toast.region.label": "Bildirimler",
  "toast.dismiss.aria": "Bildirimi kapat",
  "toast.kind.error": "Hata",
  "toast.kind.warning": "Uyarı",
  "toast.kind.info": "Bilgi",
  "toast.kind.success": "Başarılı",

  // Sprint 25 R2 lane 2 — pre-engine validation gate (TS-008)
  "validation.toast.error.title": "Devre hatası — analiz başlatılmadı",
  "validation.toast.warning.title": "Devre uyarısı",

  // Sprint 26 Lane 2 — F5 idempotent re-press feedback (R5-LAT-1)
  "toast.dc.refreshed.title": "DC analizi yenilendi",
  "toast.dc.refreshed.body": "Çalışma noktası yeniden hesaplandı",

  // Sprint 26 Lane 6 (R5-IA-8) — AC sweep + import success toasts
  "toast.ac.refreshed.title": "AC analizi yenilendi",
  "toast.ac.refreshed.body": "Bode tepkisi yeniden hesaplandı",
  "toast.import.success.title": "Devre içe aktarıldı",
  "toast.import.success.body": "Aktif belge değiştirildi (geri almak için Cmd+Z)",
  "validation.error.missing-ground": "Ground (toprak) yok — devreye GND ekleyin",
  "validation.error.dangling-pin": "Bağlanmamış pin: {component} · {terminal}",
  "validation.error.floating-net": "Boş net: {name} (kullanılmıyor)",
  "validation.error.voltage-source-short":
    "Gerilim kaynağı kısa devre: {component} (V+ ve V- aynı nete bağlı)",
  "validation.warning.isolated-subgraph": "Devre {count} ayrı parçadan oluşuyor",

  // Sprint 53 — playback speed control (VISION §6.E, audit Item 19)
  "speed.label": "Simülasyon hızı",
  "speed.settings.label": "Varsayılan simülasyon hızı",
  "speed.settings.description":
    "Açılışta uygulanır. Toolbar'daki seçim oturum boyunca geçici olarak değişir.",
  "speed.bookmark.restored": "Hız geri yüklendi: {speed}",

  // Sprint 56c — ERC UI integration (VISION §6.F P0)
  "erc.badge.title": "Devre uyarıları",
  "erc.badge.zero": "Devre temiz · kural ihlali yok",
  "erc.badge.summary.error": "{count} hata",
  "erc.badge.summary.warn": "{count} uyarı",
  "erc.badge.mixed": "{errors} hata · {warns} uyarı",
  "erc.panel.title": "Devre Kuralları",
  "erc.panel.subtitle": "Elektriksel kural denetleyicisi (ERC)",
  "erc.panel.empty.title": "Tüm kurallar geçti",
  "erc.panel.empty.body":
    "Bu devre topoloji + DC çalışma noktası seviyesinde temiz. Bileşen ekleyince otomatik tekrar koşar.",
  "erc.panel.duration": "Son denetim {ms} ms",
  "erc.panel.dc-aware": "DC bilinçli kurallar koşuldu",
  "erc.panel.dc-unaware": "DC bilinçli kurallar bekliyor (analizi başlat)",
  "erc.panel.ignored.count": "{count} ihlal bastırıldı",
  "erc.panel.ignored.toggle.show": "Bastırılanları göster",
  "erc.panel.ignored.toggle.hide": "Bastırılanları gizle",
  "erc.panel.ignored.clear": "Tümünü geri al",
  "erc.panel.action.ignore": "Bu uyarıyı bastır",
  "erc.panel.action.unignore": "Bastırmayı geri al",
  "erc.panel.action.locate": "Bileşeni bul",
  "erc.panel.close": "Paneli kapat",
  "erc.panel.severity.error": "Hata",
  "erc.panel.severity.warn": "Uyarı",
  "erc.panel.severity.info": "Bilgi",
  "erc.rule.floating-node.title": "Boşta kalan net",
  "erc.rule.missing-ground.title": "Toprak referansı eksik",
  "erc.rule.unconnected-pin.title": "Bağlantısız pin",
  "erc.rule.short-circuit.title": "Kısa devre",
  "erc.rule.saturation.title": "Bileşen doyumda",
  "erc.rule.overvoltage.title": "Aşırı gerilim",
  "erc.rule.overheating.title": "Aşırı ısınma",
  "erc.body.floating-node": "Net yalnızca tek terminale bağlı — tel eksik mi?",
  "erc.body.missing-ground": "Toprak (GND) referansı bulunamadı.",
  "erc.body.unconnected-pin": "Bileşen pini var olmayan bir nete referans veriyor.",
  "erc.body.short-circuit": "Doğrudan kısa devre — iki kaynak veya sıfır Ω direnç.",
  "erc.body.saturation": "Aktif bileşen DC OP'ta doyumda takılmış.",
  "erc.body.overvoltage": "Node gerilimi bileşen değerini aşıyor.",
  "erc.body.overheating": "Bileşen sürekli T_max sınırını aşıyor (Aşama 2 termal).",
  "erc.suggestion.floating-node": "Bu neti toprağa veya başka bir bileşene bağlayın.",
  "erc.suggestion.missing-ground": "En az bir net'i toprak olarak işaretleyin (GND referansı).",
  "erc.suggestion.unconnected-pin": "Bu terminali geçerli bir nete bağlayın veya bileşeni silin.",
  "erc.suggestion.short-circuit":
    "Akım sınırlama direnci ekleyin veya kaynak topolojisini kontrol edin.",
  "erc.suggestion.saturation": "Yük direncini artırın veya sürücü gerilimini düşürün.",
  "erc.suggestion.overvoltage":
    "Daha yüksek voltaj değerli bir bileşene geçin veya gerilim bölücü ekleyin.",
  "erc.suggestion.overheating": "Daha yüksek güç tasarımı (1W resistor vs.) veya akımı azaltın.",

  // Sprint 56b — holographic formula overlay (VISION §6.G P0)
  "formula.overlay.title": "Holografik formül",
  "formula.overlay.eyebrow": "Topoloji tanımı",
  "formula.overlay.symbolic": "Sembolik",
  "formula.overlay.numeric": "Sayısal",
  "formula.overlay.close": "Paneli kapat",
  "formula.overlay.duration": "{ms} ms",
  "formula.overlay.match-count": "{count} eşleşme",
  "formula.overlay.no-match": "Tanımlanmış bir desen bulunamadı.",
  "formula.voltage-divider.name": "Gerilim bölücü",
  "formula.rc-filter.name": "RC alçak geçiren filtre",
  "formula.led-current-limit.name": "LED akım sınırlama",
  "formula.opamp-inverting.name": "Op-amp eviren yükselteç",
  "formula.opamp-non-inverting.name": "Op-amp evirmeyen yükselteç",
  "formula.bjt-common-emitter.name": "BJT ortak emiter yükselteç",

  // Sprint 57 — polish effects (VISION §6.E P1)
  "polish.tooltip.type.resistor": "Direnç",
  "polish.tooltip.type.capacitor": "Kondansatör",
  "polish.tooltip.type.inductor": "Endüktör",
  "polish.tooltip.type.voltage-source": "Gerilim kaynağı",
  "polish.tooltip.type.ac-source": "AC kaynağı",
  "polish.tooltip.type.diode": "Diyot",
  "polish.tooltip.type.led": "LED",
  "polish.tooltip.type.bjt-npn": "BJT NPN",
  "polish.tooltip.type.bjt-pnp": "BJT PNP",
  "polish.tooltip.type.opamp": "Op-amp",
  "polish.tooltip.type.ground": "Toprak",
} as const;

export type TranslationKey = keyof typeof tr;
